import { Component, OnInit, NgZone, type ElementRef, Inject, ChangeDetectionStrategy } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { SettingsService } from '../../settings/settings.service';
import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { SharedComponentsModule } from '../../../shared/components/shared-components.module';
import { offset } from 'handsontable/helpers/dom';
import moment from 'moment';
// Unoptimized: heavy libs eagerly imported. Commented out and replaced with dynamic imports inside methods.
// import alasql from 'alasql';
// import * as XLSX from 'xlsx';
import { CookieService } from 'ngx-cookie-service';
import { DataTransferService } from 'src/app/shared/services/data-transfer.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { LocalStoreService } from 'src/app/shared/services/local-store.service';
import { environment } from 'src/environments/environment';
import { Page } from 'src/app/shared/models/page';
import { FullLoaderService } from 'src/app/shared/services/full-loader.service';
import { ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { from } from 'rxjs';
import {
  DatatableComponent,
  DatatableRowDetailDirective,
} from '@swimlane/ngx-datatable';
import { QuoteService } from '../../dashboard/quote/quote.service';
import { SupplierRfqSWRService, type RfqQuery } from './rfq-swr.service';
import { Subscription } from 'rxjs';

// Unoptimized: global alasql/XLSX wiring for browser at module load time. Commented out.
// (alasql as any).utils.isBrowserify = false;
// (alasql as any).utils.global.XLSX = XLSX;

// Unoptimized: exceljs and file-saver inflate initial bundle. Commented out; use dynamic import when needed.
// import * as Excel from 'exceljs';
// import * as FileSaver from 'file-saver';
import { RfqGenerateFormService } from '../../dashboard/rfq/rfq-generate-form/rfq-genearte-form.service';
import { CacheService } from './cache.service';

const labelMap: Record<string, string> = {
  name: 'Name',
  address: 'Address',
  contact: 'Contact',
  phone: 'Phone',
  fax: 'Fax',
  email: 'Email',
  billingAddress: 'Billing Address',
  mpsBuyerCode: 'MPS Buyer Code',
  mpsSupplierCode: 'MPS Supplier Code',
  PIC: 'PIC',
  vat: 'VAT'

};

interface Payload {
  quoteDetails: any;
  incotermDetails: any;
  supplierComment: string;
  freightForwarder: any;
  paymentTerms: any;
  lineItems: any[];
  additionalCosts: any[];
  costSummary: any;
}

@Component({
  selector: 'app-supplier-rfq-list',
  templateUrl: './supplier-rfq-list.component.html',
  styleUrls: ['./supplier-rfq-list.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SupplierRfqListComponent {
  @ViewChild('archivedSection', { static: false })
  archivedSection!: ElementRef;
  @ViewChild('heading', { static: false })
  heading!: ElementRef;
  @ViewChild('myDetailRow') table!: DatatableComponent;
  @ViewChild('myDetailRow', { static: false })
  rowDetail!: DatatableRowDetailDirective;
  menuTrigger: MatMenuTrigger | null = null;
  // supplierData: any[] = [];
  showLoader: boolean = true;
  nextMpsCode: number = 0;
  searchKeyword: string = '';

  limit: number = 10; // Rows per page
  offset: number = 0; // Current page offset
  archivedLimit: number = 10; // Rows per page
  archivedOffset: number = 0; // Current page offset
  totalRecords: number = 0; // Total number of records
  archivedTotalRecords: number = 0;
  sortField: string = 'rfqDate';
  sortDirection: string = 'desc';
  // docStatus:any;
  docStatus: string = '';
  fromDate: any;
  toDate: any;
  archivedLoaded: boolean = false;

  allDocumentData: any[] = [];
  documentData: any[] = [];
  archivedDocumentData: any[] = [];
  documentDataTotalRecords: number = 0;
  isFilterExpand: boolean = false;
  isArchivedExpand: boolean = false;
  searchParam: string = '';
  selectedRfq: number[] = [];
  selectedRfqDetails: number[] = [];
  selectedArchivedRfq: number[] = [];
  // selectedStatus: string = 'ALL';
  selectedStatus: string[] = ['ALL'];
  rfqStagesList = [
    { name: 'Unactioned', heading: 'RFQ Recieved:' },
    { name: 'Acknowledged', heading: 'RFQ Acknowledged:' },
    { name: 'Declined', heading: 'RFQ Declined:' },
    { name: 'Lost', heading: 'RFQ Lost:' },
    { name: 'Lapsed', heading: 'RFQ Lapsed:' },
    { name: 'Submitted', heading: 'RFQ Submitted:' },
    { name: 'Draft', heading: 'RFQ Drafted:' },
  ];

  quoteStagesList = [
    { name: 'Accepted', heading: 'Quotation Recieved' },
    { name: 'Declined', heading: 'Quotation Declined:' },
    { name: 'Draft', heading: 'Quotation Drafted:' },
    { name: 'Quoted', heading: 'Quotation Submitted' },
    { name: 'Withdrawn', heading: 'Quote Withdrawn:' },
  ];

  // filterStatuses = ['Acknowledged', 'Declined', 'Lost', 'Lapsed', 'Unactioned', 'ALL'];
  filterStatuses = [
    { name: 'Acknowledged', label: 'RFQ' },
    { name: 'Declined', label: 'RFQ' },
    { name: 'Lost', label: 'RFQ' },
    { name: 'Lapsed', label: 'RFQ' },
    { name: 'Unactioned', label: 'RFQ' },
    { name: 'ALL', label: 'RFQ' },
  ];
  activeIndex: number = this.filterStatuses.length - 1;
  activeIndexes: number[] = [this.filterStatuses.length - 1];
  statusColors: { [key: string]: string } = {
    Acknowledged: '#00B3B3',
    Declined: '#FF0000',
    // 'Lost': '#FFFFFF',
    Lost: '#FF0000',
    Lapsed: '#FF8A00',
    Unactioned: '#727272',
  };
  lineItems: any[] = [];
  additionalCosts: any[] = [];
  summary: any = {};
  parsed!: any ;

  supplierUsersList: any[] = [];
  // supplierUserMap: { [key: number]: string } = {};
  selectedUsers: any[] = [];
  useroffset: number = 0;
  userlimit: number = 10;
  isLoading: boolean = false;
  supplierProfileData: any = null;

  labelFromQuote: string = '';

  headerData: any;
  isChatOpen:boolean=false;
  userRole!: string;
  userId!: number;
  newMessage = '';
  messages: { sender: string; message: string; time: string }[] = [];
  showChatHistoryButton: boolean = false;
  rfqId!: number;


  otherStatus = [
    { name: 'Accepted', label: 'Quote' },
    { name: 'Declined', label: 'Quote' },
    { name: 'Draft', label: 'Quote' },
    { name: 'Quoted', label: 'Quote' },
    { name: 'Withdrawn', label: 'Quote' },
  ]

  dropdownOpen:boolean = false;
  rfqTypeDropdownOpen: boolean = false;

  previewSection = false;
  previewDocs: string[] = [];

  showContactPopup:boolean = false;
  selectedBuyer: any = {
    companyName: 'N/A',
    contactPerson: 'N/A',
    email: 'N/A',
    phone: 'N/A',
    address: 'N/A',
    fax:'N/A'

  };


  templateData:any;
  countryData:any[]=[]
  incotermsData:any[]=[]
  currencyData:any[]=[]
  paymentTermsData:any[]=[]
  offeredQualityData:any[]=[]
  taxStatusData:any[]=[]

  // Stable row identity for ngx-datatable to reduce DOM churn
  rowIdentity = (row: any) => (row?.rfqId ?? row?.id);
  private rfqListSub: Subscription | null = null;
  private currentQueryKey: string | null = null;
  private rfqArchivedSub: Subscription | null = null;
  private currentRfqArchivedQueryKey: string | null = null;
  private hasAutoExpandedAllOnce: boolean = false;
  private shouldAutoExpandFirst: boolean = true; // initial page load for ALL

  // Safely coerce API payloads to arrays. Supports shapes like { rows: [...] }.
  private toArray<T = any>(data: any, rowsKey: string = 'rows'): T[] {
    if (Array.isArray(data)) return data as T[];
    if (data && Array.isArray(data[rowsKey])) return data[rowsKey] as T[];
    return [] as T[];
  }


  alreadyAssignedSupplierUsers() {
    // Find all RFQs that already have a supplierUserName
    const alreadyAssignedRfqs = this.selectedRfq
      .map((rfqId: any) => {
        const rfq = this.documentData.find((data: any) => data.rfqId === rfqId);
        return rfq && rfq.supplierUserName ? rfq.rfqId : null;
      })
      .filter((rfqId: any) => rfqId !== null);

    console.log({ alreadyAssignedRfqs });
    if (alreadyAssignedRfqs.length > 0) {
      const rfqIds = alreadyAssignedRfqs.join(', '); // Join the RFQ IDs into a string
      this.snack.open(`User is already assigned to RFQ IDs: ${rfqIds}`, 'OK', {
        duration: 5000,
      });
      return;
    }
  }
  async toggleUserSelection(item: any) {
    // Check if any RFQs are selected
    if (this.selectedRfq.length === 0) {
      // If no RFQs are selected, show a snackbar message and return
      this.snack.open(
        'Please select at least one RFQ before selecting a user.',
        'OK',
        {
          duration: 3000,
        }
      );
      return;
    }

    item.selected = !item.selected;

    if (item.selected) {
      try {
        // Call the SettingsService to assign the user
        const response = await this.SettingsService.assignRfqSupplierUser(
          this.selectedRfq,
          Number(this.cookieService.get('userId')),
          item.id
        );
        // const result= await this.SettingsService.fetchSupplierUserByRfqId(this.selectedRfq[0]);
        // console.log({result});
        // Invalidate SWR caches and refresh
        this.rfqSWR.invalidateAll();
        await this.fetchAllDocuments();
        this.selectedRfq = [];
        item.selected = false;
        this.snack.open('User assigned to RFQ successfully.', 'OK', {
          duration: 3000,
        });
      } catch (error) {
        // If the API call fails, handle the error here
        this.snack.open('Failed to assign user to RFQ.', 'OK', {
          duration: 3000,
        });
        throw error; // Re-throw the error to be caught in the calling method
      }
    }
  }

  // Method to get status color based on the status
  getStatusColor(status: string): string {
    return this.statusColors[status] || '#000000'; // Default to black if no match
  }

  formatRfqDate(rfqDate: any): string {
    const now = moment(); // Get current time
    const diffInSeconds = now.diff(moment(rfqDate), 'seconds');
    const diffInMinutes = now.diff(moment(rfqDate), 'minutes');
    const diffInHours = now.diff(moment(rfqDate), 'hours');
    const diffInDays = now.diff(moment(rfqDate), 'days');

    // Handle the difference based on time
    if (diffInSeconds < 60) {
      return `${moment(rfqDate).format(
        'DD MMM YYYY'
      )} (${diffInSeconds} seconds ago)`;
    } else if (diffInMinutes < 60) {
      return `${moment(rfqDate).format(
        'DD MMM YYYY'
      )} (${diffInMinutes} minutes ago)`;
    } else if (diffInHours < 24) {
      return `${moment(rfqDate).format(
        'DD MMM YYYY'
      )} (${diffInHours} hours ago)`;
    } else if (diffInDays === 1) {
      return `${moment(rfqDate).format('DD MMM YYYY')} (Yesterday)`;
    } else {
      return moment(rfqDate).format('DD MMM YYYY'); // Show date with month and year
    }
  }

  columns = [
    { name: 'Buyer', prop: 'companyName', visible: true },
    { name: 'Document Type', prop: 'docType', visible: true },
    { name: 'Reference', prop: 'rfqRefNumber', visible: true },
    { name: 'Approved By', prop: 'approvedBy', visible: true },
    { name: 'Status', prop: 'docStatus', visible: true },
    { name: 'Date', prop: 'rfqDate', visible: true },

    { name: 'Quote before date', prop: 'quotedByDate', visible: false },
    { name: 'Vessel', prop: 'vesselName', visible: false },
    { name: 'Port Country', prop: 'portCountry', visible: false },
    { name: 'Port Name', prop: 'portName', visible: false },
    { name: 'Buyer Contact Name', prop: 'contact', visible: false },
    // { name: "Supplier Contact Name", prop: "rfqRefNumber", visible: false },
    // { name: "Total Cost", prop: "approvedBy", visible: false },
    { name: 'Delivery date', prop: 'requestDeliveryDate', visible: false },
    // { name: "Expiry Date", prop: "rfqDate", visible: false },
  ];

  // items = [
  //   { label: 'Port Name', prop: 'portName', selected: false },
  //   { label: 'Port Country', prop: 'portCountry', selected: false },
  //   { label: 'Request Delivery Date', prop: 'requestDeliveryDate', selected: false },
  //   { label: 'Request Delivery Time', prop: 'requested_delivery_time', selected: false },
  //   { label: 'Vessel Name', prop: 'vesselName', selected: false },
  //   { label: 'Vessel Type', prop: 'vesselType', selected: false },
  //   { label: 'Company Email Id', prop: 'companyEmailId', selected: false },
  //   { label: 'Company Phone Number', prop: 'companyPhoneNumber', selected: false },
  //   { label: 'Company Address', prop: 'companyAddress', selected: false },
  //   { label: 'Lead Delivery Time', prop: 'leadTimeInDelivery', selected: false },
  // ];

  items = [
    {
      label: 'Request Delivery Date',
      prop: 'requestDeliveryDate',
      selected: false,
    },
    // { label: 'Quote Before Date',prop:'quotedByDate',selected:false},
    { label: 'Vessel', prop: 'vesselName', selected: false },
    { label: 'Vessel ETA', prop: 'vesselEta', selected: false },
    { label: 'Vessel ETD', prop: 'vesselEtd', selected: false },
    { label: 'Owner', prop: 'supplierUserName', selected: false },
  ];

  archivedItems = [
    {
      label: 'Request Delivery Date',
      prop: 'requestDeliveryDate',
      selected: false,
    },
    // { label: 'Quote Before Date',prop:'quotedByDate',selected:false},
    { label: 'Vessel', prop: 'vesselName', selected: false },
    { label: 'Vessel ETA', prop: 'vesselEta', selected: false },
    { label: 'Vessel ETD', prop: 'vesselEtd', selected: false },
    { label: 'Owner', prop: 'supplierUserName', selected: false },
  ];

  selectedColumns: { label: string; prop: string }[] = [];
  archivedSelectedColumns: { label: string; prop: string }[] = [];

  private buildRfqQuery(activeFlag: 0 | 1): RfqQuery {
    const fromDate = this.fromDate
      ? moment(this.fromDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;
    const toDate = this.toDate
      ? moment(this.toDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;
    return {
      searchParam: this.searchParam,
      userId: Number(this.cookieService.get('userId')),
      docStatus: this.docStatus,
      fromDate,
      toDate,
      sortField: this.sortField,
      sortDirection: this.sortDirection as any,
      limit: activeFlag === 1 ? this.limit : this.archivedLimit,
      offset: activeFlag === 1 ? this.offset : this.archivedOffset,
      activeFlag,
    };
  }

  // statusMapping = [
  //     { value: 'Acknowledged', label: 'Acknowledged' },
  //     // { value: 'Acknowledged', label: 'In Progress'},
  //     // { value: 'Acknowledged', label: 'Submitted'},
  //     { value: 'Declined', label: 'Declined' },
  //     { value: 'Lost', label: 'Lost' },
  //     { value: 'Lapsed', label: 'Lapsed' },
  //     { value: 'Unactioned', label: 'Unactioned' },
  //     { value: 'ALL', label: 'ALL' },
  // ];

  constructor(
    private SettingsService: SettingsService,
    private router: Router,
    private cookieService: CookieService,
    private dataTransferService: DataTransferService<any>,
    private snack: MatSnackBar,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private ngZone: NgZone,
    private ls: LocalStoreService,
    private fullLoaderService: FullLoaderService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private quoteService: QuoteService,
    private RfqGenerateFormService:RfqGenerateFormService,
    @Inject(CacheService) private cacheService: CacheService,
    private rfqSWR: SupplierRfqSWRService,
  ) {
    iconRegistry.addSvgIcon(
      'downloadExcel',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        `${environment.assetsLink}images/excel.svg`
      )
      // this.sanitizer.bypassSecurityTrustResourceUrl(`https://mps-cdn-dev.s3.eu-west-1.amazonaws.com/assets/images/excel.svg`)
    );
  }

  async fetchAllRfqsForExportAll() {
    let fromDate = this.fromDate
      ? moment(this.fromDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;
    let toDate = this.toDate
      ? moment(this.toDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;
    // this.showLoader = true;
    // Mapping for docStatus

    try {
      const response = await this.SettingsService.fetchAllRfqBySupplierId(
        this.searchParam,
        Number(this.cookieService.get('userId')),
        this.docStatus,
        fromDate,
        toDate,
        this.sortField,
        this.sortDirection,
        Number.MAX_SAFE_INTEGER,
        0,
        1
      );

      console.log({ response });

      if (
        response &&
        Array.isArray(response.rows) &&
        typeof response.totalElements === 'number'
      ) {
        const enrichedRows = await Promise.all(
          response.rows.map(async (rfq: any) => {
            const currentDate = new Date();
            const quotedByDate = new Date(rfq.quotedByDate);

              // If the docStatus is 'Unactioned' and quotedByDate is in the past, set it to 'Lapsed'
              // if (rfq.docStatus === 'Unactioned' && quotedByDate < currentDate) {
              //   rfq.docStatus = 'Lapsed';
              // }
              if (rfq.docStatus === 'Unactioned' && rfq.quotedByDate!==null && quotedByDate < currentDate) {
                rfq.docStatus = 'Lapsed';
              }
              return rfq;
            })
          );
          
          this.allDocumentData = enrichedRows;
          console.log("Fetched Document data of all RFQ by Supplier Id for export", this.allDocumentData);
          console.log("Total records", response.totalElements);

        } else {
          console.error("Invalid response structure: missing rows or rows is not an array", response);
        }
      } catch (error) {
        console.error("Error fetching documents", error);

      } finally {
        // this.showLoader = false;
    }
  }

  async downloadDocumentDataExcel() {
    // Show loader during the export process
    this.fullLoaderService.showLoader();
    // Dynamically import XLSX to avoid adding it to initial bundle
    const XLSX = await import('xlsx');
    await this.fetchAllRfqsForExportAll();
    let formattedData: any = [];

    // Iterate through the document data and format it as needed
    this.allDocumentData.forEach((document) => {
      formattedData.push({
        Reference: document.rfqRefNumber,
        Vessel: document.vesselName,
        'Port Name': document.portName,
        Buyer: document.companyName,
        'Quotation Date': moment(document.quotedByDate).format('DD/MM/YYYY'),
        Owner: document.supplierUserName || document.supplierName,
        Status: document.docStatus,
        'RFQ Date': document.rfqDate,
        'Request Delivery Date': moment(document.requestDeliveryDate).format(
          'DD/MM/YYYY'
        ),
        'Quote Before Date': moment(document.quotedByDate).format('DD/MM/YYYY'),
        'Vessel ETA': moment(document.vesselEta).format('DD/MM/YYYY'),
        'Vessel ETD': moment(document.vesselEtd).format('DD/MM/YYYY'),
      });
    });

    // Create a new worksheet from the formatted data
    const ws: any = XLSX.utils.json_to_sheet(formattedData);
    const wb: any = XLSX.utils.book_new();

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Document Data');

    // Write the file to disk or trigger the download
    XLSX.writeFile(wb, 'Document Data Export.xlsx');

    // Hide the loader after the export is complete
    this.fullLoaderService.hideLoader();
  }


  // async ngOnInit() {
  //   const queryParams = this.route.snapshot.queryParamMap;



  //   if (queryParams.keys.length > 0) {
  //     const updatedStatus = queryParams.get('updatedStatus');
  //     if (updatedStatus) {
  //       this.docStatus = updatedStatus;
  //       // this.selectedStatus=updatedStatus;
  //       this.selectedStatus = [updatedStatus];
  //       this.isFilterExpand = true;
  //     }
  //   }

  //   this.route.queryParams.subscribe((params) => {
  //     const statusParam = params['selectedStatus'];
  //     const labelParam = params['label'];
  //     console.log('statusParam', statusParam);
  //     console.log('labelParam', labelParam);

  //     if (statusParam && labelParam) {
  //       //  When params are present, use them
  //       this.selectedStatus = statusParam;
  //       this.labelFromQuote = labelParam;
  //       this.docStatus = statusParam;
  //       this.setActiveStatus(statusParam, labelParam);
  //     } else {
  //       //  Fallback when params are NOT provided
  //       this.docStatus = '';
  //       this.selectedStatus = ['ALL'];
  //     }
  //   });

  //   // await this.fetchSupplierProfileData();
  //   // await this.fetchAllUsersBySupplierId();
  //   this.userId = Number(this.cookieService.get('userId'));
  //   this.userRole = this.cookieService.get('userRole');
  //   if(this.userRole == 'Suppliers' ){
  //     this.showChatHistoryButton= true;
  //   }
  //   await this.fetchAllDocuments();

  //   this.fullLoaderService.showLoader()
  //   this.countryData = await this.SettingsService.fetchAllCountryDetails();
  //   this.incotermsData = await this.quoteService.fetchAllIncoterms();
  //   this.paymentTermsData = await this.RfqGenerateFormService.getAllpaymentTerms();
  //   this.offeredQualityData = await this.quoteService.fetchAllOfferedQuality();
  //   this.currencyData = await this.quoteService.fetchAllCurrency()
  //   await this.getTaxDetails()
  //   this.fullLoaderService.hideLoader()


  //  // await this.fetchArchivedAllDocuments();
  //   // await this.fetchUsers();
  // }

  
  // Approach of fetching data parallely from all the apis.

  // async ngOnInit() {
  //   const queryParams = this.route.snapshot.queryParamMap;

  //   if (queryParams.keys.length > 0) {
  //     const updatedStatus = queryParams.get('updatedStatus');
  //     if (updatedStatus) {
  //       this.docStatus = updatedStatus;
  //       this.selectedStatus = [updatedStatus];
  //       this.isFilterExpand = true;
  //     }
  //   }

  //   this.route.queryParams.subscribe((params) => {
  //     const statusParam = params['selectedStatus'];
  //     const labelParam = params['label'];

  //     if (statusParam && labelParam) {
  //       this.selectedStatus = statusParam;
  //       this.labelFromQuote = labelParam;
  //       this.docStatus = statusParam;
  //       this.setActiveStatus(statusParam, labelParam);
  //     } else {
  //       this.docStatus = '';
  //       this.selectedStatus = ['ALL'];
  //     }
  //   });

  //   this.userId = Number(this.cookieService.get('userId'));
  //   this.userRole = this.cookieService.get('userRole');

  //   if (this.userRole === 'Suppliers') {
  //     this.showChatHistoryButton = true;
  //   }

  //   // await this.fetchAllDocuments();

  //   this.fullLoaderService.showLoader();

  //   let data = {
  //     supplierId: Number(this.cookieService.get('userId')),
  //   };

  //   const start = performance.now();
  //   const apiResults = await Promise.allSettled([
  //     this.SettingsService.fetchAllCountryDetails(),  
  //     this.quoteService.fetchAllIncoterms(),        
  //     this.RfqGenerateFormService.getAllpaymentTerms(), 
  //     this.quoteService.fetchAllOfferedQuality(),  
  //     this.quoteService.fetchAllCurrency(),     
  //     this.getTaxDetails(),
  //     this.fetchAllDocuments()                  
  //   ]);

  //   const end = performance.now();

  //   console.log("APIs took:", (end - start).toFixed(2), "ms");

  //   // Assign values safely (if API failed, fallback to empty array or default)
  //   this.countryData =
  //     apiResults[0].status === 'fulfilled' ? apiResults[0].value : [];

  //   this.incotermsData =
  //     apiResults[1].status === 'fulfilled' ? apiResults[1].value : [];

  //   this.paymentTermsData =
  //     apiResults[2].status === 'fulfilled' ? apiResults[2].value : [];

  //   this.offeredQualityData =
  //     apiResults[3].status === 'fulfilled' ? apiResults[3].value : [];

  //   this.currencyData =
  //     apiResults[4].status === 'fulfilled' ? apiResults[4].value : [];

  //   if (apiResults[5].status !== 'fulfilled') {
  //     console.warn("Tax details API failed");
  //   }

  //   this.fullLoaderService.hideLoader();
  // }


//Approached of fetching Aggregated data + parallel fetching of apis.

//   async ngOnInit() {
  
//   const queryParams = this.route.snapshot.queryParamMap;

//   if (queryParams.keys.length > 0) {
//     const updatedStatus = queryParams.get('updatedStatus');
//     if (updatedStatus) {
//       this.docStatus = updatedStatus;
//       this.selectedStatus = [updatedStatus];
//       this.isFilterExpand = true;
//     }
//   }

//   this.route.queryParams.subscribe((params) => {
//     const statusParam = params['selectedStatus'];
//     const labelParam = params['label'];

//     if (statusParam && labelParam) {
//       this.selectedStatus = statusParam;
//       this.labelFromQuote = labelParam;
//       this.docStatus = statusParam;
//       this.setActiveStatus(statusParam, labelParam);
//     } else {
//       this.docStatus = '';
//       this.selectedStatus = ['ALL'];
//     }
//   });

//   this.userId = Number(this.cookieService.get('userId'));
//   this.userRole = this.cookieService.get('userRole');

//   if (this.userRole === 'Suppliers') {
//     this.showChatHistoryButton = true;
//   }

//   this.fullLoaderService.showLoader();

//   const requestObj = {
//     supplierId: this.userId
//   };

//   const start = performance.now();

//   const [aggregatedResult, documentsResult] = await Promise.allSettled([
//     this.RfqGenerateFormService.fetchSupplierRfqListRequiredData(requestObj),
//     this.fetchAllDocuments()
//   ]);

//   const end = performance.now();
//   console.log("Parallel APIs took:", (end - start).toFixed(2), "ms");

//   if (aggregatedResult.status === "fulfilled") {
//     const response = aggregatedResult.value;

//     this.countryData = response?.countries || [];
//     this.incotermsData = response?.incoterms || [];
//     this.paymentTermsData = response?.paymentTerms || [];
//     this.offeredQualityData = response?.offeredQuality || [];
//     this.currencyData = response?.currencies || [];
//     this.taxStatusData = response?.taxProfiles || [];

//     if (this.taxStatusData?.length) {
//       const taxStatusDataOptions = this.taxStatusData
//         .map((q) => q.applicableTaxProfile)
//         .join(",");
      
//       console.log({taxStatusDataOptions});
//     }
//   } else {
//     console.error("Aggregated API failed:", aggregatedResult.reason);
//   }

//   if (documentsResult.status !== "fulfilled") {
//     console.error("Fetch documents failed:", documentsResult.reason);
//   }

//   this.fullLoaderService.hideLoader();
// }

  //Approached of fetching Aggregated data + parallel fetching of apis + caching.
  async ngOnInit() {

  const queryParams = this.route.snapshot.queryParamMap;

  if (queryParams.keys.length > 0) {
    const updatedStatus = queryParams.get('updatedStatus');
    if (updatedStatus) {
      this.docStatus = updatedStatus;
      this.selectedStatus = [updatedStatus];
      this.isFilterExpand = true;
    }
  }

  this.route.queryParams.subscribe((params) => {
    const statusParam = params['selectedStatus'];
    const labelParam = params['label'];

    if (statusParam && labelParam) {
      this.selectedStatus = statusParam;
      this.labelFromQuote = labelParam;
      this.docStatus = statusParam;
      this.setActiveStatus(statusParam, labelParam);
    } else {
      this.docStatus = '';
      this.selectedStatus = ['ALL'];
    }
  });

  this.userId = Number(this.cookieService.get('userId'));
  this.userRole = this.cookieService.get('userRole');

  if (this.userRole === 'Suppliers') {
    this.showChatHistoryButton = true;
  }

  this.fullLoaderService.showLoader();

  const requestObj = { supplierId: this.userId };
  const cacheKey = "supplierRfqMasterData_" + this.userId;

  const start = performance.now();


  let cachedData = this.cacheService.get(cacheKey);

  let aggregatedPromise;

  if (cachedData) {
    console.log("Loaded master data from cache");
    aggregatedPromise = Promise.resolve(cachedData);
  } else {
    aggregatedPromise = this.RfqGenerateFormService
      .fetchSupplierRfqListRequiredData(requestObj)
      .then((data) => {
        this.cacheService.set(cacheKey, data);
        return data;
      });
  }

  const [aggregatedResult, documentsResult] = await Promise.allSettled([
    aggregatedPromise,
    this.fetchAllDocuments()
  ]);

  const end = performance.now();
  // console.log("Parallel APIs took:", (end - start).toFixed(2), "ms");


  
  if (aggregatedResult.status === "fulfilled") {
    const response = aggregatedResult.value;

    this.countryData = response?.countries || [];
    this.incotermsData = response?.incoterms || [];
    this.paymentTermsData = response?.paymentTerms || [];
    this.offeredQualityData = response?.offeredQuality || [];
    this.currencyData = response?.currency || [];
    this.taxStatusData = response?.taxDetails || [];

    if (this.taxStatusData?.length) {
      const taxStatusDataOptions = this.taxStatusData
        .map((q) => q.applicableTaxProfile)
        .join(",");

      console.log({ taxStatusDataOptions });
    }
  } else {
    console.error("Aggregated API failed:", aggregatedResult.reason);
  }


  
  if (documentsResult.status !== "fulfilled") {
    console.error("Fetch documents failed:", documentsResult.reason);
  }

  this.fullLoaderService.hideLoader();
}

  get userIdAsString(): string {
    return this.userId.toString();
  }
  setActiveStatus(status: string, label: string) {
    const index = this.filterStatuses.findIndex(
      (s) => s.name === status && s.label === label
    );
    if (index !== -1) {
      this.activeIndexes = [index];
      this.selectedStatus = [status];
      this.docStatus = status;
    } else {
      //  If not found, still default to ALL
      this.docStatus = '';
      this.selectedStatus = ['ALL'];
    }
  }

  // async fetchAllUsersBySupplierId(): Promise<void> {
  //   const supplierId = Number(this.cookieService.get('userId'));

  //   try {
  //     const response = await this.SettingsService.fetchAllUsersBySupplierId(supplierId).toPromise();
  //     console.log({response});
  //     if (response && Array.isArray(response.rows)) {
  //       // Populate the supplierUserMap with userId -> userName
  //       response.rows.forEach((user: any) => {
  //         this.supplierUserMap[user.id] = `${user.firstName} ${user.lastName}`;
  //       });
  //       console.log('Supplier User Map:', this.supplierUserMap);
  //     } else {
  //       console.error('Invalid user response structure:', response);
  //     }
  //   } catch (error) {
  //     console.error('Error fetching supplier users:', error);
  //   }
  // }

  // async fetchAllDocuments(){

  //   let fromDate = this.fromDate ? moment(this.fromDate).format("YYYY-MM-DDTHH:mm:ss") + "Z" : null;
  //   let toDate = this.toDate ? moment(this.toDate).format("YYYY-MM-DDTHH:mm:ss") + "Z" : null;

  //   this.showLoader = true;

  //    const response= await this.SettingsService.fetchAllRfqBySupplierId(this.searchParam, Number(this.cookieService.get('userId')), this.docStatus, fromDate, toDate, this.sortField, this.sortDirection, this.limit, this.offset,1)

  //   if (response && Array.isArray(response.rows) && typeof response.totalElements === 'number') {
  //     // Properly set the response data
  //     this.documentData = response.rows;
  //     console.log("fetched Document data of all rfq by Supplier Id",this.documentData);
  //     this.totalRecords = response.totalElements;

  //     this.showLoader = false;

  //   } else {
  //     console.error('Invalid response structure', response);
  //   }

  // }

  // Function to get value from label
  // getStatusValueFromLabel = (label: string): string => {
  //   const status = this.statusMapping.find(status => status.label === label);
  //   return status ? status.value : label; // Return value or label if not found
  // };
  // getLabelValueFromStatus = (value:string):string =>{
  //   const status = this.statusMapping.find(status=> status.value === value);
  //   return status? status.label :value;
  // }
  // Handle status selection

  onStatusSelect(status: string, index: number, label: string) {
    this.activeIndex = index;
    if (label === 'RFQ') {
      if (this.selectedStatus.includes(status)) {
        return;
      }
      if (
        this.selectedStatus[0] === 'Unactioned' &&
        status === 'Acknowledged'
      ) {
        this.selectedStatus.push('Acknowledged');
        this.activeIndexes.push(index);
        this.docStatus += `,Acknowledged`;
      } else if (
        this.selectedStatus[0] === 'Acknowledged' &&
        status === 'Unactioned'
      ) {
        this.selectedStatus.push('Unactioned');
        this.activeIndexes.push(index);
        this.docStatus += `,Unactioned`;
      } else {
        if (status !== 'ALL') {
          this.docStatus = status;
        } else {
          this.docStatus = '';
        }
        this.selectedStatus = [status];
        this.activeIndexes = [index];
      }
      // Reset expansion on filter change; only auto-expand once for ALL on first load
      this.expandedQuoteId = null;
      this.shouldAutoExpandFirst = status === 'ALL' && !this.hasAutoExpandedAllOnce;
      this.offset = 0;

      this.fetchAllDocuments();
    } else if (label === 'Quote') {
      this.router.navigate(['/operations/supplier-quote-list'], {
        queryParams: {
          selectedStatus: status,
          label: label,
        },
      });
    }
  }

  //   getRemainingTime(row: any): { label: string; color: string; tooltip: string } {
  //   if (!row.quotedByDate || ['Lost', 'Declined'].includes(row.docStatus)) {
  //     if(row.docStatus=='Declined'){
  //       return { label: '-', color: 'black', tooltip: 'You have declined this RFQ' };
  //     }else if(row.docStatus=='Lost'){
  //        return { label: '-', color: 'black', tooltip: 'RFQ awarded to another Supplier' };
  //     }
  //     return { label: '-', color: 'black', tooltip: 'Quotation date Deadline not mentioned' };
  //   }

  //   const now = moment();
  //   const quoteDate = moment(row.quotedByDate);
  //   const diffInDays = quoteDate.diff(now, 'days');

  //   if (diffInDays > 7) {
  //     return { label: `> 7 days`, color: '#0BA716', tooltip: `RFQ due in ${diffInDays} days` };
  //   } else if (diffInDays >= 4 && diffInDays <= 7) {
  //     return { label: `4-7 days`, color: '#FD8900', tooltip: `RFQ due in ${diffInDays} days` };
  //   } else if (diffInDays >= 1 && diffInDays <= 3) {
  //     return { label: `1-3 days`, color: '#F60303', tooltip: `RFQ due in ${diffInDays} days` };
  //   } else if (diffInDays <0) {
  //     return { label: 'Overdue', color: '#000000', tooltip: 'Quote window closed' };
  //   } else {
  //     const diffInHours = quoteDate.diff(now, 'hours');
  //     const diffInMinutes = quoteDate.diff(now, 'minutes');
  //     const diffInSeconds = quoteDate.diff(now, 'seconds');

  //     if (diffInHours >= 1) {
  //       return { label: `${diffInHours} hr${diffInHours > 1 ? 's' : ''}`, color: '#000000', tooltip: `RFQ due in ${diffInHours} hours` };
  //     } else if (diffInMinutes >= 1) {
  //       return { label: `${diffInMinutes} min${diffInMinutes > 1 ? 's' : ''}`, color: '#000000', tooltip: `RFQ due in ${diffInMinutes} minutes` };
  //     } else if(diffInSeconds>=1){
  //       return { label: `${diffInSeconds} sec${diffInSeconds > 1 ? 's' : ''}`, color: '#000000', tooltip: `RFQ due in ${diffInSeconds} seconds` };
  //     }else{
  //       return { label: 'Overdue', color: '#000000', tooltip: 'Quote window closed'};
  //     }
  //   }
  // }

  // getRemainingTime(row: any): { label: string; color: string; tooltip: string } {
  //   if (!row.quotedByDate || ['Lost', 'Declined'].includes(row.docStatus)) {
  //     if(row.docStatus=='Declined'){
  //       return { label: '-', color: 'black', tooltip: 'You have declined this RFQ' };
  //     }else if(row.docStatus=='Lost'){
  //        return { label: '-', color: 'black', tooltip: 'RFQ awarded to another Supplier' };
  //     }
  //     return { label: '-', color: 'black', tooltip: 'Quotation date Deadline not mentioned' };
  //   }

  //   const now = moment();
  //   const quoteDate = moment(row.quotedByDate);
  //   const diffInDays = quoteDate.diff(now, 'days');

  //   if (diffInDays > 7) {
  //     return { label: `Low`, color: '#0BA716', tooltip: `RFQ due in ${diffInDays} days` };
  //   } else if (diffInDays >= 4 && diffInDays <= 7) {
  //     return { label: `Medium`, color: '#FD8900', tooltip: `RFQ due in ${diffInDays} days` };
  //   } else if (diffInDays >= 1 && diffInDays <= 3) {
  //     return { label: `Top`, color: '#F60303', tooltip: `RFQ due in ${diffInDays} days` };
  //   } else if (diffInDays <0) {
  //     return { label: 'Overdue', color: '#000000', tooltip: 'Quote window closed' };
  //   } else {
  //     const diffInHours = quoteDate.diff(now, 'hours');
  //     const diffInMinutes = quoteDate.diff(now, 'minutes');
  //     const diffInSeconds = quoteDate.diff(now, 'seconds');

  //     if (diffInHours >= 1) {
  //       return { label: `Top (${diffInHours} hr${diffInHours > 1 ? 's' : ''}) Left`, color: '#F60303', tooltip: `RFQ due in ${diffInHours} hours` };
  //     } else if (diffInMinutes >= 1) {
  //       return { label: `Top (${diffInMinutes} min${diffInMinutes > 1 ? 's' : ''}) Left`, color: '#F60303', tooltip: `RFQ due in ${diffInMinutes} minutes` };
  //     } else if(diffInSeconds>=1){
  //       return { label: `Top (${diffInSeconds} sec${diffInSeconds > 1 ? 's' : ''}) Left`, color: '#F60303', tooltip: `RFQ due in ${diffInSeconds} seconds` };
  //     }else{
  //       return { label: 'Overdue', color: '#000000', tooltip: 'Quote window closed'};
  //     }
  //   }
  // }

  getRemainingTime(row: any): {
    label: string;
    color: string;
    tooltip: string;
  } {
    if (
      !row.quotedByDate ||
      ['Lost', 'Declined', 'Lapsed'].includes(row.docStatus)
    ) {
      // if(row.docStatus=='Declined'){
      //   return { label: '-', color: 'black', tooltip: 'You have declined this RFQ' };
      // }else if(row.docStatus=='Lost'){
      //    return { label: ' ', color: 'black', tooltip: 'RFQ awarded to another Supplier' };
      // }
      // return { label: '-', color: 'black', tooltip: 'Quotation date Deadline not mentioned' };
      return { label: '', color: 'black', tooltip: '' };
    }

    const now = moment();
    const quoteDate = moment(row.quotedByDate);
    const diffInDays = quoteDate.diff(now, 'days');

    if (diffInDays > 7) {
      return {
        label: `New`,
        color: '#0BA716',
        tooltip: `RFQ due in ${diffInDays} days`,
      };
    } else if (diffInDays >= 4 && diffInDays <= 7) {
      return {
        label: `Standard`,
        color: '#FD8900',
        tooltip: `RFQ due in ${diffInDays} days`,
      };
    } else if (diffInDays >= 1 && diffInDays <= 3) {
      return {
        label: `Urgent`,
        color: '#F60303',
        tooltip: `RFQ due in ${diffInDays} days`,
      };
    } else if (diffInDays < 0) {
      // return { label: 'Overdue', color: '#000000', tooltip: 'Quote window closed' };
      return { label: '', color: '#000000', tooltip: '' };
    } else {
      const diffInHours = quoteDate.diff(now, 'hours');
      const diffInMinutes = quoteDate.diff(now, 'minutes');
      const diffInSeconds = quoteDate.diff(now, 'seconds');

      if (diffInHours >= 1) {
        return {
          label: `Urgent (${diffInHours} hr${diffInHours > 1 ? 's' : ''} Left)`,
          color: '#F60303',
          tooltip: `RFQ due in ${diffInHours} hours`,
        };
      } else if (diffInMinutes >= 1) {
        return {
          label: `Urgent (${diffInMinutes} min${
            diffInMinutes > 1 ? 's' : ''
          } Left)`,
          color: '#F60303',
          tooltip: `RFQ due in ${diffInMinutes} minutes`,
        };
      } else if (diffInSeconds >= 1) {
        return {
          label: `Urgent (${diffInSeconds} sec${
            diffInSeconds > 1 ? 's' : ''
          } Left)`,
          color: '#F60303',
          tooltip: `RFQ due in ${diffInSeconds} seconds`,
        };
      } else {
        // return { label: 'Overdue', color: '#000000', tooltip: 'Quote window closed'};
        // return { label: '-', color: '#000000', tooltip: 'Quote window closed'};
        return { label: '', color: '#000000', tooltip: '' };
      }
    }
  }

  getRemainingTimeForQuoteDate(row: any): {
    label: string;
    color: string;
    tooltip: string;
  } {
    const now = moment();
    const quoteDate = moment(row.quotedByDate);
    const diffInDays = quoteDate.diff(now, 'days');

    if (diffInDays > 7) {
      return {
        label: `New`,
        color: '#0BA716',
        tooltip: `RFQ due in ${diffInDays} days`,
      };
    } else if (diffInDays >= 4 && diffInDays <= 7) {
      return {
        label: `Standard`,
        color: '#FD8900',
        tooltip: `RFQ due in ${diffInDays} days`,
      };
    } else if (diffInDays >= 1 && diffInDays <= 3) {
      return {
        label: `Urgent`,
        color: '#F60303',
        tooltip: `RFQ due in ${diffInDays} days`,
      };
    } else if (diffInDays < 0) {
      return { label: 'Overdue', color: '#000000', tooltip: '' };
    } else {
      const diffInHours = quoteDate.diff(now, 'hours');
      const diffInMinutes = quoteDate.diff(now, 'minutes');
      const diffInSeconds = quoteDate.diff(now, 'seconds');

      if (diffInHours >= 1) {
        return {
          label: `Urgent (${diffInHours} hr${diffInHours > 1 ? 's' : ''} Left)`,
          color: '#F60303',
          tooltip: `RFQ due in ${diffInHours} hours`,
        };
      } else if (diffInMinutes >= 1) {
        return {
          label: `Urgent (${diffInMinutes} min${
            diffInMinutes > 1 ? 's' : ''
          } Left)`,
          color: '#F60303',
          tooltip: `RFQ due in ${diffInMinutes} minutes`,
        };
      } else if (diffInSeconds >= 1) {
        return {
          label: `Urgent (${diffInSeconds} sec${
            diffInSeconds > 1 ? 's' : ''
          } Left)`,
          color: '#F60303',
          tooltip: `RFQ due in ${diffInSeconds} seconds`,
        };
      } else {
        return { label: 'Overdue', color: '#000000', tooltip: '' };
      }
    }
  }

  async fetchSupplierProfileData(): Promise<void> {
    const supplierId = Number(this.cookieService.get('userId')); // Adjust if supplierId is stored elsewhere
    console.log({ supplierId });
    try {
      const response = await this.SettingsService.getSupplierProfileData(
        supplierId
      );
      if (response) {
        this.supplierProfileData = response; // Store the fetched profile data
        console.log('Supplier Profile Data:', this.supplierProfileData);
      } else {
        console.error('No data found for supplier profile');
      }
    } catch (error) {
      console.error('Error fetching supplier profile data:', error);
    }
  }

  async fetchAllDocuments() {
    let fromDate = this.fromDate
      ? moment(this.fromDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;
    let toDate = this.toDate
      ? moment(this.toDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;

    console.log({ fromDate });
    console.log({ toDate });
    console.log('docStatus', this.docStatus);
    console.log('sortField', this.sortField);
    console.log('sortDirection', this.sortDirection);
    console.log('limit', this.limit);
    console.log('offset', this.offset);
    this.showLoader = true;
    // Mapping for docStatus

    try {
      // SWR: serve cached immediately, refresh in background
      const q: RfqQuery = {
        searchParam: this.searchParam,
        userId: Number(this.cookieService.get('userId')),
        docStatus: this.docStatus,
        fromDate,
        toDate,
        sortField: this.sortField,
        sortDirection: this.sortDirection,
        limit: this.limit,
        offset: this.offset,
        activeFlag: 1,
      };

      const key = this.rfqSWR.keyOf(q);
      const needsResubscribe = this.currentQueryKey !== key;
      if (needsResubscribe) {
        if (this.rfqListSub) {
          this.rfqListSub.unsubscribe();
          this.rfqListSub = null;
        }
        this.currentQueryKey = key;
        this.rfqListSub = this.rfqSWR.getList$(q, true).subscribe(async (response) => {
          if (!response || !Array.isArray(response.rows)) {
            return;
          }
          const enrichedRows = await Promise.all(
            response.rows.map(async (rfq: any) => {
              const currentDate = new Date();
              const quotedByDate = new Date(rfq.quotedByDate);
              rfq.id = rfq.id ?? rfq.rfqId ?? rfq.rfqDetailsId;
              if (rfq.docStatus === 'Unactioned' && rfq.quotedByDate !== null && quotedByDate < currentDate) {
                rfq.docStatus = 'Lapsed';
              }
              rfq.statusColor = this.statusColors?.[rfq.docStatus] || '#727272';
              rfq.rfqDateFormatted = rfq.rfqDate ? moment(rfq.rfqDate).format('DD/MM/YYYY') : '-';
              rfq.remaining = this.getRemainingTime(rfq);
              rfq.remainingQuote = this.getRemainingTimeForQuoteDate(rfq);
              return rfq;
            })
          );

          this.documentData = enrichedRows;
          // Expansion logic: only auto-expand once for ALL on initial load
          if (this.expandedQuoteId == null && this.documentData.length > 0 && this.shouldAutoExpandFirst) {
            const first = this.documentData[0];
            this.expandedQuoteId = first.id;
            if (!first.statusesStages) {
              first.statusesStages = this.buildRfqStages(first);
              first.statusesStages = this.buildOtherStages(first);
            }
            this.hasAutoExpandedAllOnce = true;
            this.shouldAutoExpandFirst = false;
          }
          // If a row is already marked as expanded (e.g., user toggled), ensure it has stages
          if (this.expandedQuoteId != null) {
            const match = this.documentData.find((r: any) => (r.id ?? r.rfqId) === this.expandedQuoteId);
            if (match && !match.statusesStages) {
              match.statusesStages = this.buildRfqStages(match);
              match.statusesStages = this.buildOtherStages(match);
            }
          }
          this.totalRecords = response.totalElements ?? 0;
          this.documentData = [...this.documentData];
          this.showLoader = false;
          this.cdr.markForCheck();
        });
      }

      // Show full loader only when we have no cached data for this query
      const cached = this.rfqSWR.getCached(q);
      if (!cached) {
        this.fullLoaderService.showLoader();
        try {
          await this.rfqSWR.refresh(q);
        } finally {
          this.fullLoaderService.hideLoader();
        }
      } else {
        // Trigger background refresh without blocking UI
        this.rfqSWR.refresh(q);
      }
      return; // prevent running the old fetch code below
      // console.log('searchparam', this.searchParam);
      // console.log('docStatus', this.docStatus);
      // const response = await this.SettingsService.fetchAllRfqBySupplierId(
      //   this.searchParam,
      //   Number(this.cookieService.get('userId')),
      //   this.docStatus,
      //   fromDate,
      //   toDate,
      //   this.sortField,
      //   this.sortDirection,
      //   this.limit,
      //   this.offset,
      //   1
      // );

      // console.log({ response });

      // if (
      //   response &&
      //   Array.isArray(response.rows) &&
      //   typeof response.totalElements === 'number'
      // ) {
      //   const enrichedRows = await Promise.all(
      //     response.rows.map(async (rfq: any) => {
      //       const currentDate = new Date();
      //       const quotedByDate = new Date(rfq.quotedByDate);

      //       // Normalize an id field for UI expansion and identity
      //       rfq.id = rfq.id ?? rfq.rfqId ?? rfq.rfqDetailsId;

      //       // If the docStatus is 'Unactioned' and quotedByDate is in the past, set it to 'Lapsed'
      //       if (rfq.docStatus === 'Unactioned' && rfq.quotedByDate !== null && quotedByDate < currentDate) {
      //         rfq.docStatus = 'Lapsed';
      //       }

      //       // Precompute UI-only fields to avoid calling functions from template repeatedly
      //       rfq.statusColor = this.statusColors?.[rfq.docStatus] || '#727272';
      //       rfq.rfqDateFormatted = rfq.rfqDate ? moment(rfq.rfqDate).format('DD/MM/YYYY') : '-';
      //       rfq.remaining = this.getRemainingTime(rfq);
      //       rfq.remainingQuote = this.getRemainingTimeForQuoteDate(rfq);

      //       // Unoptimized (commented): building full timeline for every row on list load
      //       // rfq.statusesStages = this.buildRfqStages(rfq);
      //       // rfq.statusesStages = this.buildOtherStages(rfq);

      //       return rfq;
      //     })
      //   );

      //   this.documentData = enrichedRows;
      //   // Auto-expand the first row on initial load
      //   if (this.expandedQuoteId == null && this.documentData.length > 0) {
      //     const first = this.documentData[0];
      //     this.expandedQuoteId = first.id;
      //     if (!first.statusesStages) {
      //       first.statusesStages = this.buildRfqStages(first);
      //       first.statusesStages = this.buildOtherStages(first);
      //     }
      //   }
      //   this.documentData = [...this.documentData];
      //   console.log(
      //     'Fetched Document data of all RFQ by Supplier Id with updated status',
      //     this.documentData
      //   );
      //   console.log({response});
      //   this.totalRecords = response.totalElements;
      //   console.log('Total records', this.totalRecords);
      // } else {
      //   console.error(
      //     'Invalid response structure: missing rows or rows is not an array',
      //     response
      //   );
      // }
    } catch (error) {
      console.error('Error fetching documents', error);
    } finally {
      this.showLoader = false;
      // OnPush: mark for check after async update
      this.cdr.markForCheck();
    }
  }

  async fetchArchivedAllDocuments() {
    const fromDate = this.fromDate
      ? moment(this.fromDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;
    const toDate = this.toDate
      ? moment(this.toDate).format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      : null;

    try {
      const q: RfqQuery = {
        searchParam: this.searchParam,
        userId: Number(this.cookieService.get('userId')),
        docStatus: this.docStatus,
        fromDate,
        toDate,
        sortField: this.sortField,
        sortDirection: this.sortDirection as any,
        limit: this.archivedLimit,
        offset: this.archivedOffset,
        activeFlag: 0,
      };

      const key = this.rfqSWR.keyOf(q);
      const needsResubscribe = this.currentRfqArchivedQueryKey !== key;
      const cached = this.rfqSWR.getCached(q);
      this.showLoader = !cached;

      if (needsResubscribe) {
        if (this.rfqArchivedSub) {
          this.rfqArchivedSub.unsubscribe();
          this.rfqArchivedSub = null;
        }
        this.currentRfqArchivedQueryKey = key;
        this.rfqArchivedSub = this.rfqSWR.getList$(q, true).subscribe(async (response) => {
          if (!response || !Array.isArray(response.rows)) return;
          const enrichedRows = await Promise.all(
            response.rows.map(async (rfq: any) => {
              const currentDate = new Date();
              const quotedByDate = new Date(rfq.quotedByDate);
              rfq.id = rfq.id ?? rfq.rfqId ?? rfq.rfqDetailsId;
              if (rfq.docStatus === 'Unactioned' && rfq.quotedByDate !== null && quotedByDate < currentDate) {
                rfq.docStatus = 'Lapsed';
              }
              rfq.statusColor = this.statusColors?.[rfq.docStatus] || '#727272';
              rfq.rfqDateFormatted = rfq.rfqDate ? moment(rfq.rfqDate).format('DD/MM/YYYY') : '-';
              rfq.remaining = this.getRemainingTime(rfq);
              rfq.remainingQuote = this.getRemainingTimeForQuoteDate(rfq);
              return rfq;
            })
          );
          this.archivedDocumentData = enrichedRows;
          this.archivedTotalRecords = response.totalElements ?? 0;
          this.showLoader = false;
          this.cdr.markForCheck();
        });
      }

      if (!cached) {
        this.fullLoaderService.showLoader();
        try {
          await this.rfqSWR.refresh(q);
        } finally {
          this.fullLoaderService.hideLoader();
        }
      } else {
        this.rfqSWR.refresh(q);
      }
    } catch (error) {
      console.error('Error fetching archived documents', error);
    } finally {
      this.showLoader = false;
      this.cdr.markForCheck();
    }
  }

  setRowClass = (row: any) => {
    return 'green-row-background';
  };

  toggleSelection(item: any) {
    item.selected = !item.selected;
    console.log(
      'Selected items:',
      this.items.filter((i) => i.selected)
    );
    this.updateSelectedColumns();
  }

  archivedToggleSelection(item: any) {
    item.selected = !item.selected;
    console.log(
      'Selected items:',
      this.archivedItems.filter((i) => i.selected)
    );
    this.updateArchivedSelectedColumns();
  }

  // toggleUserSelection(item: any): void {
  //     item.selected = !item.selected;
  //     if (item.selected) {
  //       this.selectedUsers.push(item);
  //     } else {
  //       this.selectedUsers = this.selectedUsers.filter(user => user.id !== item.id);
  //     }
  //     console.log(this.selectedUsers);  // Log the selected users
  //   }

  onScroll(): void {
    const menuContent = document.querySelector('.menu-content') as HTMLElement;
    // Check if we've reached the bottom of the menu content
    if (
      menuContent.scrollTop + menuContent.clientHeight >=
        menuContent.scrollHeight &&
      !this.isLoading
    ) {
      if (this.supplierUsersList.length == this.userlimit * this.useroffset) {
        this.fetchUsers();
      } else {
        this.isLoading = false;
      }
    }
  }

  // Fetch users based on pagination offset and limit
  async fetchUsers(): Promise<void> {
    this.isLoading = true;

    try {
      const response = await this.SettingsService.fetchUserBySupplierId(
        Number(this.cookieService.get('userId')), // supplierId
        this.userlimit, // limit
        this.useroffset // offset
      ).toPromise();

      if (response && Array.isArray(response.rows)) {
        this.supplierUsersList = [...this.supplierUsersList, ...response.rows];
        this.useroffset++; // Increment offset for next batch of users

        console.log('supplierUserList', this.supplierUsersList);
      } else {
        console.error('Invalid response structure:', response);
      }
    } catch (error) {
      console.error('Error fetching supplier users:', error);
    } finally {
      this.isLoading = false;
    }
  }
  // Update selected columns based on checkbox selection
  // updateSelectedColumns() {
  //   this.selectedColumns = this.items.filter(item => item.selected).map(item => item.prop);
  // }

  updateSelectedColumns() {
    // Create a map of label to prop
    this.selectedColumns = this.items
      .filter((item) => item.selected) // Filter selected items
      .map((item) => ({ label: item.label, prop: item.prop })); // Create key-value pairs (label -> prop)
  }

  updateArchivedSelectedColumns() {
    this.archivedSelectedColumns = this.archivedItems
      .filter((item) => item.selected) // Filter selected items
      .map((item) => ({ label: item.label, prop: item.prop })); // Create key-value pairs (label -> prop)

    console.log('archieve selected columns', this.archivedSelectedColumns);
  }
  isDate(value: any): boolean {
    return value instanceof Date || !isNaN(Date.parse(value));
  }

  // Method to handle page change event from ngx-datatable
  onPageChange(event: any) {
    this.offset = event.offset; // Update offset from the page change event
    this.selectedRfq = [];
    this.fetchAllDocuments(); // Fetch data with new offset
  }

  // Method to handle search functionality
  onSearch() {
    this.offset = 0; // Reset offset for new search
    this.archivedOffset = 0;
    this.fetchAllDocuments();
    this.fetchArchivedAllDocuments();
  }

  // Handle sort change event from ngx-datatable
  onSort(event: any) {
    const sort = event.sorts[0];
    this.sortField = sort.prop;
    this.sortDirection = sort.dir;

    // Apply sorting and fetch data accordingly
    // Note: Sorting in your backend should be implemented to support `sortField` and `sortDirection`
    this.fetchAllDocuments();
  }

  onArchivedSort(event: any) {}

  onArchivedPageChange(event: any) {
    this.archivedOffset = event.offset; // Update offset from the page change event
    this.fetchArchivedAllDocuments(); // Fetch data with new offset
  }

  async OpenRfq(rfqDetailsId: number, supplierId: number) {
    // let data = {
    //   supplierId: supplierId,
    //   rfqId: rfqDetailsId
    // }
    // const pdf = await this.SettingsService.generateSupplierRfqAttachment(data)

    // const uint8Array = new Uint8Array(pdf.data);
    // const blob = new Blob([uint8Array], { type: 'application/pdf' });
    // const url = URL.createObjectURL(blob);
    //  window.open(url);
    const newWindow = window.open('', '_blank'); // Open immediately

    if (!newWindow) {
      alert('Popup blocked. Please allow popups for this site.');
      return;
    }

    let data = {
      supplierId: supplierId,
      rfqId: rfqDetailsId,
    };

    try {
      const pdf = await this.SettingsService.generateSupplierRfqAttachment(
        data
      );
      const uint8Array = new Uint8Array(pdf.data);
      const blob = new Blob([uint8Array], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);

      newWindow.location.href = url;
    } catch (error) {
      newWindow.close(); // Cleanup
      console.error('Failed to open RFQ PDF', error);
      alert('Failed to open PDF. Please try again.');
    }
  }

  async downloadRfq(rfqDetailsId: number, supplierId: number, refNo: string) {
    this.showLoader = true;

    let fileName = refNo + '.pdf';

    let data = {
      supplierId: supplierId,
      rfqId: rfqDetailsId,
    };
    const pdf = await this.SettingsService.generateSupplierRfqAttachment(data);

    const uint8Array = new Uint8Array(pdf.data);
    const blob = new Blob([uint8Array], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);

    // Create a temporary <a> element
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    this.showLoader = false;
  }

  OpenSupplierProductPopUp(isNew?: boolean, row?: any, userId?: any) {
    this.router.navigate(
      [
        'dataManagement',
        {
          outlets: {
            'form-outlet': ['product-binding', userId],
          },
        },
      ],
      {
        state: { supplierId: userId }, // Add your data here
      }
    );
  }

  OpenSupplierPreviewPopup(row?: any, userId?: any, companyId?: any) {
    this.router.navigate([
      // "dataManagement",
      // 'pro',
      //  userId
      'settings',
      'profile',
      'about',
      userId,
      companyId,
    ]);
  }

  OpenSupplierProfilePopup(row?: any, userId?: any, companyId?: any) {
    this.router.navigate(['settings', 'supplierProfile', userId, companyId]);
  }

  // Unoptimized export using global alasql removed. Use downloadDocumentDataExcel instead.
  async exportAll() {
    await this.downloadDocumentDataExcel();
  }

  toggleVisibility() {
    this.isFilterExpand = !this.isFilterExpand;
  }

  // toggleArchived() {
  //   this.isArchivedExpand = !this.isArchivedExpand;
  //   if (this.isArchivedExpand && this.heading) {
  //     this.heading.nativeElement.scrollIntoView({
  //       behavior: 'smooth', // Smooth scroll
  //       block: 'start', // Align the section to the top of the viewport
  //     });
  //     setTimeout(() => {
  //       if (this.archivedSection) {
  //         this.heading.nativeElement.scrollIntoView({
  //           behavior: 'smooth',
  //           block: 'start', // Align the table at the top of the viewport after heading
  //         });
  //       }
  //     }, 100);
  //   }
  // }

  async toggleArchived() {
    this.isArchivedExpand = !this.isArchivedExpand;
    if (this.isArchivedExpand) {
      // Lazy-load archived data on first expand
      if (!this.archivedLoaded) {
        await this.fetchArchivedAllDocuments();
        this.archivedLoaded = true;
      }

      if (this.heading) {
        this.heading.nativeElement.scrollIntoView({
          behavior: 'smooth', // Smooth scroll
          block: 'start', // Align the section to the top of the viewport
        });
        setTimeout(() => {
          if (this.archivedSection) {
            this.heading.nativeElement.scrollIntoView({
              behavior: 'smooth',
              block: 'start', // Align the table at the top of the viewport after heading
            });
          }
        }, 100);
      }
    }
  }

  isColumnVisible(prop: string): boolean {
    const column = this.columns.find((col) => col.prop === prop);
    return column ? column.visible : false;
  }

  search() {}
  cancelFilter() {
    this.fromDate = null;
    this.toDate = null;
    this.offset = 0;
    this.archivedOffset = 0;
    this.selectedStatus = ['ALL'];
    this.docStatus = '';
    this.fetchAllDocuments();
    this.fetchArchivedAllDocuments();
  }

  toggleColumn(column: any) {
    column.visible = !column.visible;
  }

  toggleSelectAll(event: any, section: string) {
    const checked = event.target.checked;
    // const ids = this.documentData.map(item => item.supplierRfqDetailsId);
    const ids = this.documentData.map((item) => item.rfqId);

    if (section == 'active') {
      if (checked) {
        // this.selectedRfq = this.documentData.map(item => item.supplierRfqDetailsId);
        this.selectedRfq = this.documentData.map((item) => item.rfqId);
        this.selectedRfqDetails = this.documentData.map(
          (item) => item.supplierRfqDetailsId
        );
      } else {
        this.selectedRfq = [];
      }
    } else {
      if (checked) {
        this.selectedArchivedRfq = this.archivedDocumentData.map(
          (item) => item.rfqId
        );
      } else {
        this.selectedArchivedRfq = [];
      }
    }
  }

  selectDeselectRfq(
    event: any,
    supplierRfqDetailsId: any,
    rfqId: any,
    section: string,
    owner: any
  ) {
    const checked = event.target.checked;

    if (section == 'active') {
      if (checked) {
        this.selectedRfq.push(rfqId);
        this.selectedRfqDetails.push(supplierRfqDetailsId);
        if(owner!== null){
          this.snack.open(`User is already assigned to RFQ ID ${rfqId}`, 'OK', {
            duration: 5000,
          });
        }
      } else {
        this.selectedRfq = this.selectedRfq.filter((id) => id !== rfqId);
        this.selectedRfqDetails = this.selectedRfqDetails.filter(
          (id) => id !== supplierRfqDetailsId
        );
      }
    } else {
      if (checked) {
        this.selectedArchivedRfq.push(rfqId);
      } else {
        this.selectedArchivedRfq = this.selectedArchivedRfq.filter(
          (id) => id !== rfqId
        );
      }
    }
  }

  // selectDeselectRfq(event:any, supplierRfqDetailsId:any, section:string,owner:any){

  //   const checked = event.target.checked;

  //   if(section == 'active'){
  //     if(checked){
  //       this.selectedRfq.push(supplierRfqDetailsId)
  //       if(owner!=='-'){
  //         this.snack.open(`User is already assigned to RFQ ID ${supplierRfqDetailsId}`, 'OK', {
  //           duration: 5000,
  //         });
  //       }
  //     }
  //     else{
  //       this.selectedRfq = this.selectedRfq.filter(id => id !== supplierRfqDetailsId);
  //     }
  //   }
  //   else{
  //     if(checked){
  //       this.selectedArchivedRfq.push(supplierRfqDetailsId)
  //     }
  //     else{
  //       this.selectedArchivedRfq = this.selectedArchivedRfq.filter(id => id !== supplierRfqDetailsId);
  //     }
  //   }
  // }

  async RestoreRfq(isConfirmed: boolean, row: any) {
    if (isConfirmed) {
      try {
        this.showLoader = true;
        await this.SettingsService.rfqOperations({
          operation: 'unArchive',
          selectedRfqId: [row.supplierRfqDetailsId],
        });
        // Optimistically move one item from archived -> active
        const idx = this.archivedDocumentData.findIndex((r: any) => r.rfqId === row.rfqId);
        if (idx !== -1) {
          const [moved] = this.archivedDocumentData.splice(idx, 1);
          this.documentData = [moved, ...this.documentData];
          this.totalRecords += 1;
          this.archivedTotalRecords = Math.max(0, this.archivedTotalRecords - 1);
          const qArchived = this.buildRfqQuery(0);
          const qActive = this.buildRfqQuery(1);
          this.rfqSWR.patchList(qArchived, (resp: any) => {
            const rows = (resp?.rows || []).filter((r: any) => r.rfqId !== row.rfqId);
            const total = Math.max(0, (resp?.totalElements ?? 0) - 1);
            return { ...resp, rows, totalElements: total };
          });
          this.rfqSWR.patchList(qActive, (resp: any) => {
            const rows = [moved].concat(resp?.rows || []);
            const total = (resp?.totalElements ?? 0) + 1;
            return { ...resp, rows, totalElements: total };
          });
        }
        // Background refresh
        const qActive2 = this.buildRfqQuery(1);
        const qArchived2 = this.buildRfqQuery(0);
        this.rfqSWR.refresh(qActive2);
        if (this.archivedLoaded) this.rfqSWR.refresh(qArchived2);
        this.snack.open('RFQ has been restored successfully!', 'OK', { duration: 3000 });
      } catch (error) {
        console.error('Error while restoring RFQ:', error);
        this.snack.open('Failed to restore RFQ. Please try again.', 'OK', {
          duration: 3000,
        });
      } finally {
        this.showLoader = false;
      }
    } else {
      this.snack.open('Restore operation was canceled.', 'OK', {
        duration: 3000,
      });
    }
  }

  async rfqOperation(operation: string) {
    if (operation == 'unarchive') {
      if (this.selectedArchivedRfq.length == 0) {
        this.snack.open('Please select atleast one', 'OK', {
          duration: 3000,
        });
        return;
      }

      this.showLoader = true;
      await this.SettingsService.rfqOperations({
        operation: operation,
        selectedRfqId: this.selectedArchivedRfq,
      });
      // Optimistically move items from archived -> active
      const unarchivedIds = new Set(this.selectedArchivedRfq);
      const toUnarchive = this.archivedDocumentData.filter((row: any) => unarchivedIds.has(row.rfqId));
      this.archivedDocumentData = this.archivedDocumentData.filter((row: any) => !unarchivedIds.has(row.rfqId));
      if (toUnarchive.length > 0) {
        this.documentData = [...toUnarchive, ...this.documentData];
        this.totalRecords += toUnarchive.length;
        this.archivedTotalRecords = Math.max(0, this.archivedTotalRecords - toUnarchive.length);
      }
      // Patch caches for current pages
      const qArchived = this.buildRfqQuery(0);
      const qActive = this.buildRfqQuery(1);
      this.rfqSWR.patchList(qArchived, (resp: any) => {
        const rows = (resp?.rows || []).filter((r: any) => !unarchivedIds.has(r.rfqId));
        const total = Math.max(0, (resp?.totalElements ?? 0) - toUnarchive.length);
        return { ...resp, rows, totalElements: total };
      });
      this.rfqSWR.patchList(qActive, (resp: any) => {
        const rows = toUnarchive.concat(resp?.rows || []);
        const total = (resp?.totalElements ?? 0) + toUnarchive.length;
        return { ...resp, rows, totalElements: total };
      });
      this.snack.open('Items unarchived', 'OK', { duration: 3000 });
    } else {
      if (this.selectedRfq.length == 0) {
        this.snack.open('Please select atleast one.', 'OK', {
          duration: 3000,
        });
        return;
      }

      let data = {
        operation: operation,
        selectedRfqId: this.selectedRfqDetails,
      };

      if (operation == 'archive') {
        this.showLoader = true;
        await this.SettingsService.rfqOperations(data);
        // Optimistically move items from active -> archived
        const archivedIds = new Set(this.selectedRfq);
        const toArchive = this.documentData.filter((row: any) => archivedIds.has(row.rfqId));
        this.documentData = this.documentData.filter((row: any) => !archivedIds.has(row.rfqId));
        if (toArchive.length > 0 && this.archivedLoaded) {
          this.archivedDocumentData = [...toArchive, ...this.archivedDocumentData];
          this.archivedTotalRecords += toArchive.length;
        }
        this.totalRecords = Math.max(0, this.totalRecords - toArchive.length);
        // Patch caches for current pages
        const qActive = this.buildRfqQuery(1);
        const qArchived2 = this.buildRfqQuery(0);
        this.rfqSWR.patchList(qActive, (resp: any) => {
          const rows = (resp?.rows || []).filter((r: any) => !archivedIds.has(r.rfqId));
          const total = Math.max(0, (resp?.totalElements ?? 0) - toArchive.length);
          return { ...resp, rows, totalElements: total };
        });
        if (this.archivedLoaded) {
          this.rfqSWR.patchList(qArchived2, (resp: any) => {
            const rows = toArchive.concat(resp?.rows || []);
            const total = (resp?.totalElements ?? 0) + toArchive.length;
            return { ...resp, rows, totalElements: total };
          });
        }
        // Reset expanded row if needed
        if (this.expandedQuoteId && archivedIds.has(this.expandedQuoteId)) {
          this.expandedQuoteId = null;
          if (this.documentData.length > 0) {
            const first = this.documentData[0];
            this.expandedQuoteId = first.id;
            if (!first.statusesStages) {
              first.statusesStages = this.buildRfqStages(first);
              first.statusesStages = this.buildOtherStages(first);
            }
          }
        }
        this.snack.open('Items archived', 'OK', { duration: 3000 });
      } else if (operation == 'markAsOpen') {
        this.showLoader = true;
        await this.SettingsService.rfqOperations(data);
        this.snack.open('Items marked as open', 'OK', {
          duration: 3000,
        });
      } else if (operation == 'markAsUnopen') {
        this.showLoader = true;
        await this.SettingsService.rfqOperations(data);
        this.snack.open('Items marked as unopen', 'OK', {
          duration: 3000,
        });
      }
    }
    // Background revalidation only; no blocking loaders
    const qActive = this.buildRfqQuery(1);
    const qArchived = this.buildRfqQuery(0);
    this.rfqSWR.refresh(qActive);
    if (this.archivedLoaded) {
      this.rfqSWR.refresh(qArchived);
    }
    this.selectedArchivedRfq = [];
    this.selectedRfq = [];
    this.showLoader = false;
  }

  // isChecked(supplierRfqDetailsId:number, section:string){
  //   if(section == 'active'){
  //     return this.selectedRfq.includes(supplierRfqDetailsId)
  //   }
  //   else{
  //     return this.selectedArchivedRfq.includes(supplierRfqDetailsId)
  //   }

  // }
  isChecked(rfqId: number, section: string) {
    if (section == 'active') {
      return this.selectedRfq.includes(rfqId);
    } else {
      return this.selectedArchivedRfq.includes(rfqId);
    }
  }
  openRfqDetails(rfqId: number) {
    console.log('asdddf');
    this.router.navigate(['/dashboard', 'quote', 'rfq-details', rfqId]);
  }

  expandedQuoteId: number | null = null;

  toggleExpandedRow(row: any) {
    this.expandedQuoteId = this.expandedQuoteId === row.id ? null : row.id;
    // Lazy compute timeline only when a row is expanded, cache on the row
    if (this.expandedQuoteId === row.id && !row.statusesStages) {
      row.statusesStages = this.buildRfqStages(row);
      row.statusesStages = this.buildOtherStages(row);
    }
  }

  ngOnDestroy() {
    if (this.rfqListSub) {
      this.rfqListSub.unsubscribe();
      this.rfqListSub = null;
    }
    if (this.rfqArchivedSub) {
      this.rfqArchivedSub.unsubscribe();
      this.rfqArchivedSub = null;
    }
  }

  buildRfqStages(rfq: any) {
    const sortedStages = (rfq.rfqStatusStages || []).sort(
      (a: any, b: any) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
    );

    const stagesArray: any[] = [];
    let hasAcknowledged = false;
    let hasDeclined = false;
    let hasUnactioned = false;
    let hasCreated = false;
    let createdDate = '';
    let hasDraft = false;

    for (let stage of sortedStages) {
      if (stage.statusName === 'Acknowledged' && stage.userId == Number(this.cookieService.get('userId'))) hasAcknowledged = true;
      else if (stage.statusName === 'Declined' && stage.userId == Number(this.cookieService.get('userId'))) hasDeclined = true;
      else if (stage.statusName === 'Unactioned' && stage.userId == Number(this.cookieService.get('userId'))) hasUnactioned = true;
      else if (stage.statusName === 'Created') hasCreated = true;
      else if (stage.statusName === 'Draft') {
        hasDraft = true;
        createdDate = this.formatDate(stage.createdAt);
      }



    }


    sortedStages.forEach((stage: any) => {
      if (
        (stage.entityType === 'RFQ' || stage.entityType === 'Quotation') &&
        stage.statusId === 3 &&
        stage.userId ===  Number(this.cookieService.get('userId')) 
      ) {
        return; // Skip this stage
      }

      if (
        (stage.entityType === 'RFQ') &&
        stage.statusName === 'Declined' &&
        stage.userId !=  Number(this.cookieService.get('userId')) 
      ) {
        return; // Skip this stage
      }
      if (
        (stage.entityType === 'RFQ') &&
        stage.statusName === 'Acknowledged' &&
        stage.userId !=  Number(this.cookieService.get('userId')) 
      ) {
        return; // Skip this stage
      }

    
    
      stagesArray.push({
        heading: this.getHeadingFromLabel(stage.statusName, 'RFQ'),
        label: `RFQ ${stage.statusName}`,
        date: this.formatDate(stage.createdAt),
        completed: true,
      });
    });

    

    // If RFQ is lapsed, append it at the end (if not already in stages)
    if (
      rfq.docStatus === 'Lapsed' &&
      !stagesArray.some((s) => s.label === 'Lapsed')
    ) {
      stagesArray.push({
        heading: this.getHeadingFromLabel('Lapsed', 'RFQ'),
        label: 'RFQ Lapsed',
        date: this.formatDate(rfq.quotedByDate),
        completed: true,
      });
    }
    // If Acknowledged is missing and Declined is also missing → add Acknowledged
      if (!hasAcknowledged && !hasDeclined) {
      stagesArray.push({
        heading: this.getHeadingFromLabel('Acknowledged', 'RFQ'),
        label: 'RFQ Acknowledged',
        date: '',
        completed: false,
      });
    }

    return stagesArray;
  }

  buildOtherStages(rfq: any) {

    console.log("buildOtherStages",rfq);
    
    let stagesArray = rfq.statusesStages || [];

    stagesArray.push({
      heading: this.getHeadingFromLabel('Quoted', 'Quote'),
      label: 'Quoted',
      date: rfq.docStatus === 'Submitted' ? this.formatDate(rfq.quotationSubmittedDate) : '',
      completed: rfq.docStatus === 'Submitted' ? true : false,
    });

    stagesArray.push({
      heading: 'PO Confirmation',
      label: 'PO Confirmation',
      date: '',
      completed: false,
    });

    stagesArray.push({
      heading: 'Delivered Onboard',
      label: 'Delivered',
      date: '',
      completed: false,
    });

    return stagesArray;
  }

  getHeadingFromLabel(label: string, entityType: 'RFQ' | 'Quote'): string {
    const list =
      entityType === 'RFQ' ? this.rfqStagesList : this.quoteStagesList;
    const match = list.find(
      (stage) => stage.name.toLowerCase() === label.toLowerCase()
    );
    return match ? match.heading : label;
  }

  isRfqLapsed(quotedByDate: string | Date): boolean {
    return new Date() > new Date(quotedByDate);
  }

  formatDate(date: string | Date): string {
    return new Date(date).toLocaleDateString('en-GB');
  }
  //  formatDate(date: string | Date): string {
  //   const d = new Date(date);
  //   return d.toLocaleString('en-GB');
  // }

  getStageColorClass(label: string, row: any): string {
    if (row.docStatus === 'Declined') {
      return 'stage-declined';
    }

    // console.log('label received ->', label);
    switch (label) {
      case 'Declined':
        return 'stage-declined';
      case 'Lapsed':
        return 'stage-lapsed';
      default:
        return 'stage-completed';
    }
  }

  getCompleteIncompleteClass(stage: any): string {
    return stage.completed ? '' : 'stage-incomplete';
  }

  // toggleExpand(row: any) {
  //   if (this.expandedQuoteId === row.id) {
  //     // Collapse
  //     this.rowDetail.toggleExpandRow(row);
  //     this.expandedQuoteId = null;
  //   } else {
  //     // Expand
  //     this.rowDetail.toggleExpandRow(row);
  //     this.expandedQuoteId = row.id;
  //   }
  // }

  async onUserMenuOpened() {
    console.log('User menu opened');
    console.log('Current supplierUsersList:', this.supplierUsersList)
    if (!this.supplierUsersList.length && !this.isLoading) {
      await this.fetchUsers();
    }
    console.log('Supplier Users List:', this.supplierUsersList);
  }

  openChat(rfq: any) {
    console.log("openChat Called.... ",rfq);
    this.headerData = {
      rfqId: rfq.rfqId,
      rfqDate: rfq.rfqDate,
      rfqRefNumber: rfq.rfqRefNumber,
      vesselName: rfq.vesselName,
      vesselImoNumber: rfq.vesselImoNumber,
      portName: rfq.portName,
      vesselEta: rfq.vesselEta,
      vesselEtd: rfq.vesselEtd,
      buyerId: Number(rfq.buyerId),
      supplierId: Number(this.cookieService.get('userId')),
    };
    console.log("Header Data sending from supplier-rfq-list:", this.headerData);

    this.isChatOpen = true;
  }

  closeChat() {
    this.isChatOpen = false;
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  toggleRfqTypeDropdown() {
    this.rfqTypeDropdownOpen = !this.rfqTypeDropdownOpen;
  }

  navigateToRfqType(type: string) {
    if (type === 'product') {
      this.router.navigate(['/operations/supplier-rfq-list']);
    } else if (type === 'service') {
      this.router.navigate(['/operations/supplier-service-rfq-list']);
    }
  }


togglePreview(value: boolean, row?: any ) {
  this.previewSection = value;
  this.previewDocs = [];
  console.log(row.buyerAttachments,row.lineItemAttachments,'row')
  if (row) {
     this.previewDocs = [...row.buyerAttachments, ...row.lineItemAttachments]
  }
}

toggleContactPopUp(value: boolean, row?: any){
  this.showContactPopup = value;

  if(value){
    if(row){

      this.selectedBuyer = {
        companyName: row.buyerCompanyName,
        contactPerson: row.buyerContact,
        email: row.companyEmailId,
        phone: row.buyerCompanyPhoneNumber,
        address: row.buyerCompanyAddress,
        fax: row.buyerCompanyFax
    
      };

    }

  }
}


async generateRFQExcelForSupplier(rfqId: number, supplierId:number, ref:string) {

  this.fullLoaderService.showLoader()

  let params = {
    supplierId: Number(supplierId),
    rfqId: Number(rfqId),
  };
  const result = await this.quoteService.fetchRfqDetails(params)
  
  console.log(result,'result')

  const fileName = ref + '.xlsx'

  const data = {
    rfqRef: result.rfqData[0].rfqRefNumber,
    rfqDate: result.rfqData[0].rfqDate,
    preferredCurrency: result.rfqData[0].currencyId.currencyCode,
    vesselName: result.rfqData[0].vesselName,
    imoNumber: result.rfqData[0].vesselImoNumber,
    quoteByDate: result.rfqData[0].quotedByDate,
    requestedDeliveryDate: result.rfqData[0].requestDeliveryDate,
    buyerDetails: {  
      name: result.rfqData[0].buyerCompanyName,
      address: result.rfqData[0].companyAddress,
      contact: result.rfqData[0].contact,
      phone: result.rfqData[0].companyPhoneNumber,
      email: result.rfqData[0].companyEmailId,
      mpsBuyerCode: result.rfqData[0].mpsBuyerCode,
    },
    supplierDetails: {
      name: result.lineItemData[0].s_companyName,
      address: `${result.lineItemData[0].s_street}, ${result.lineItemData[0].s_city}, ${result.lineItemData[0].s_country}, ${result.lineItemData[0].s_zipcode}`,
      contact: result.lineItemData[0].s_contactPerson,
      phone: result.lineItemData[0].s_phone1,
      email: result.lineItemData[0].s_primaryEmail,
      mpsSupplierCode: result.lineItemData[0].mpsSupplierCode,
    },
    freightForwarderDetails: {
      PIC: result.rfqData[0].rffdPic,
      phone: result.rfqData[0].rffdphone,
      fax: result.rfqData[0].rffdfax,
      email: result.rfqData[0].rffdemailId,
      address: result.rfqData[0].rffdaddress,
    },
    portAgentDetails: {
      name: result.rfqData[0].portAgencyName,
      phone: result.rfqData[0].rfqPortAgentphone,
      fax: result.rfqData[0].rfqPortAgentfax,
      email: result.rfqData[0].rfqPortAgentemailId,
      contact: result.rfqData[0].rfqPortAgentContact,
    },
    portDetails: {
      portName: result.rfqData[0].portName,
      vesselETA: result.rfqData[0].vesselEta,
      vesselETD: result.rfqData[0].vesselEtd,
    },
    lineItems: result.lineItemData.map((item: { partNumber: any; itemDescription: any; quantity: any; uom: any; buyerComments: any; }, index: number) => ({
      srNo: index + 1,
      partNumber: item.partNumber,
      itemDescription: item.itemDescription,
      qty: item.quantity,
      uom: item.uom,
      buyerComments: item.buyerComments,
      
    }))
  };

  

  // Dynamic import to avoid adding exceljs to initial bundle
  const Excel = await import('exceljs');
  const fileSaverMod = await import('file-saver');
  const saveAs = (fileSaverMod as any).saveAs || (fileSaverMod as any).default;
  const workbook = new Excel.Workbook();
  const ws = workbook.addWorksheet('RFQ');

  // === TITLE ===
  ws.mergeCells('A1:G1');
  const title = ws.getCell('A1');
  title.value = 'Request For Quotation';
  title.font = { size: 18, bold: true, color: { argb: '1F4E78' } };
  title.alignment = { horizontal: 'center', vertical: 'middle' };
  ws.addRow([]);

  // === RFQ DETAILS HEADER ===
  const rfqHeader = ws.addRow(['RFQ DETAILS']);
  rfqHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'D9E1F2' } };
  rfqHeader.getCell(1).font = { bold: true };
  ws.addRow([]);

  // RFQ Info
  const rfqInfo = [
    ['RFQ Ref:', data.rfqRef, '', '', '', 'RFQ Date:', data.rfqDate],
    ['Preferred Currency:', data.preferredCurrency, '', '', '', 'Vessel Name:', data.vesselName],
    ['IMO Number:', data.imoNumber, '', '', '', 'Quote By Date:', data.quoteByDate],
    ['Requested Delivery Date:', data.requestedDeliveryDate],
  ];
  rfqInfo.forEach(r => {
    const row = ws.addRow(r);
    row.eachCell((c: any) => (c.alignment = { vertical: 'middle' }));
  });
  ws.addRow([]);


    // === FREIGHT FORWARDER + PORT AGENT ===
    const BsHeader = ws.addRow(['Buyer Details', '', '', 'Supplier Details']);
    BsHeader.eachCell((c: any) => {
      c.font = { bold: true };
      c.fill = { type: 'pattern', pattern: 'solid', fgColor:  { argb: 'FFF2CC' } };
    });
    ws.addRow([]);

    const buyerEntries = Object.entries(data.buyerDetails).map(([key, value]) => [
      labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase()),
      value
    ]);
    
    const supplierEntries = Object.entries(data.supplierDetails).map(([key, value]) => [
      labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase()),
      value
    ]);
    
    // Pad so both arrays have the same length
    const BsmaxRows = Math.max(buyerEntries.length, supplierEntries.length);
    const paddedBuyer = [...buyerEntries, ...Array(BsmaxRows - buyerEntries.length).fill(['', ''])];
    const paddedSupplier = [...supplierEntries, ...Array(BsmaxRows - supplierEntries.length).fill(['', ''])];
    
  
    for (let i = 0; i < BsmaxRows; i++) {
      const row = ws.addRow([
        paddedBuyer[i][0], paddedBuyer[i][1],
        '',
        paddedSupplier[i][0], paddedSupplier[i][1]
      ]);
    
    
      row.eachCell((cell: any) => {
        cell.alignment = { vertical: 'middle', wrapText: true };
      });
    }

    // const BsmaxRows = Math.max(
    //   Object.keys(data.buyerDetails).length,
    //   Object.keys(data.supplierDetails).length
    // );
    // const bd = Object.entries(data.buyerDetails);
    // const bpad = Array(BsmaxRows - bd.length).fill(['', '']);
    // const bpad2 = Array(BsmaxRows - Object.entries(data.supplierDetails).length).fill(['', '']);
    // const bpadData = bd.concat(bpad);
    // const supp = Object.entries(data.supplierDetails).concat(bpad2);
  
    // for (let i = 0; i < BsmaxRows; i++) {
    //   ws.addRow([
    //     bpadData[i][0],
    //     bpadData[i][1],
    //     '',
    //     supp[i][0],
    //     supp[i][1],
    //   ]);
    // }
  
    ws.addRow([]);
  

  // === FREIGHT FORWARDER + PORT AGENT ===
  const faHeader = ws.addRow(['Freight Forwarder Details', '', '', 'Port Agent Details']);
  faHeader.eachCell((c: any) => {
    c.font = { bold: true };
    c.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'E2EFDA' } };
  });
  ws.addRow([]);
  // const maxRows = Math.max(
  //   Object.keys(data.freightForwarderDetails).length,
  //   Object.keys(data.portAgentDetails).length
  // );
  // const ffd = Object.entries(data.freightForwarderDetails);
  // const pad = Array(maxRows - ffd.length).fill(['', '']);
  // const pad2 = Array(maxRows - Object.entries(data.portAgentDetails).length).fill(['', '']);
  // const padData = ffd.concat(pad);
  // const padAgent = Object.entries(data.portAgentDetails).concat(pad2);

  // for (let i = 0; i < maxRows; i++) {
  //   ws.addRow([
  //     padData[i][0],
  //     padData[i][1],
  //     '',
  //     padAgent[i][0],
  //     padAgent[i][1],
  //   ]);
  // }

  const freightEntries = Object.entries(data.freightForwarderDetails).map(([key, value]) => [
    labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase()),
    value
  ]);
  
  const portAgentEntries = Object.entries(data.portAgentDetails || {}).map(([key, value]) => [
    labelMap[key] || key.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase()),
    value
  ]);
  
  // Ensure equal number of rows for both sections
  const maxRows = Math.max(freightEntries.length, portAgentEntries.length);
  const paddedFreight = [...freightEntries, ...Array(maxRows - freightEntries.length).fill(['', ''])];
  const paddedPortAgent = [...portAgentEntries, ...Array(maxRows - portAgentEntries.length).fill(['', ''])];
  
  // Add rows to worksheet (no borders, clean formatting)
  for (let i = 0; i < maxRows; i++) {
    const row = ws.addRow([
      paddedFreight[i][0], paddedFreight[i][1],
      '',
      paddedPortAgent[i][0], paddedPortAgent[i][1]
    ]);
  
  
  }



  ws.addRow([]);

  // === PORT DETAILS ===
  const portHeader = ws.addRow(['Port Details']);
  portHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FCE4D6' } };
  portHeader.getCell(1).font = { bold: true };
  ws.addRow([]);
  ws.addRow(['Port Name', data.portDetails.portName]);
  ws.addRow(['Vessel ETA', data.portDetails.vesselETA]);
  ws.addRow(['Vessel ETD', data.portDetails.vesselETD]);
  ws.addRow([]);

  // === LINE ITEMS ===
  const liHeader = ws.addRow(['Line Items']);
  liHeader.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'BDD7EE' } };
  liHeader.getCell(1).font = { bold: true };
  ws.addRow([]);

    const tableHeader = ws.addRow([
    'Sr. No',
    'Part Number',
    'Item Description',
    'Qty',
    'UOM',
    'Buyer Comments'
    
  ]);
  tableHeader.eachCell((cell: any) => {
    cell.font = { bold: true };
    cell.alignment = { horizontal: 'center', vertical: 'middle' };
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'D9D9D9' } };
    cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
  });



  data.lineItems.forEach((item: { attachedSuppliers: any[]; srNo: any; partNumber: any; itemDescription: any; qty: any; uom: any; buyerComments: any; }) => {

    const row = ws.addRow([
      item.srNo,
      item.partNumber,
      item.itemDescription,
      item.qty,
      item.uom,
      item.buyerComments
      
    ]);

    row.eachCell((cell: any) => {
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      cell.alignment = { wrapText: true, vertical: 'middle' };
    });
  });
  

    ws.addRow([]);  

    // VSMPS Buyer and Supplier section
    ws.addRow([`From VSMPS Buyer: ${data.buyerDetails.mpsBuyerCode}`]);
    ws.addRow([data.buyerDetails.name]);
    ws.addRow([data.buyerDetails.address]);


    ws.addRow([]);  

    ws.addRow([`To VSMPS Supplier: ${data.supplierDetails.mpsSupplierCode}`]); 
    ws.addRow([data.supplierDetails.name]);
    ws.addRow([data.supplierDetails.address]);

    
    ws.addRow([]);

   
    ws.addRow(['Copyright © Varuna Sentinels BV. All rights reserved.']);


  // ws?.lastRow?.getCell(1).alignment = { horizontal: 'left' };
  // ws.lastRow?.getCell(1).font = { italic: true, size: 9, color: { argb: '808080' } };

  // === AUTO WIDTH ===
  const colCount = ws.actualColumnCount;
  for (let i = 1; i <= colCount; i++) {
    let maxLen = 12;
    ws.eachRow({ includeEmpty: true }, (r) => {
      const val = r.getCell(i).value;
      const len = val ? val.toString().length : 0;
      if (len > maxLen) maxLen = len;
    });
    ws.getColumn(i).width = Math.min(maxLen + 4, 40);
  }

  workbook.xlsx.writeBuffer().then((buffer: ArrayBuffer) => {
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, fileName);
  });


  this.fullLoaderService.hideLoader()

}



async onFileChange(evt: any) {

  this.fullLoaderService.showLoader()

  const file = evt.target.files[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = async (e: any) => {
    const XLSX = await import('xlsx');
    const data = new Uint8Array(e.target.result);
    const workbook = XLSX.read(data, { type: 'array' });
    const sheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[sheetName];
    const rows: any[][] = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: '' });

    const parsed = this.parseTemplateRows(rows);
    const result = this.validateParsedQuote(parsed);

    if (!result.valid) {
      console.error('Validation failed:', result.errors);
      this.fullLoaderService.hideLoader()
      this.snack.open('Validation Error:\n' + result.errors?.join('\n'), 'OK', {
        duration: 5000,
      });

      return;
    }


    const checkKeys = this.checkRequiredKeys(parsed);

    if (!checkKeys.valid) {
      console.error(' Missing keys:', checkKeys.missing);
      this.fullLoaderService.hideLoader()
      this.snack.open('Missing required keys:\n' + checkKeys.missing.join('\n'), 'OK', { duration: 5000 });
      return;
    }
    
    console.log('Parsed Sections:', parsed);

    this.lineItems = parsed.lineItems;
    
    this.additionalCosts = parsed.additionalCosts;
    this.summary = parsed.costSummary;


   const importResult = await this.quoteService.importQuoteByExcel(parsed)

   const message = importResult?.[0]?.[0]?.message || 'No message found';
   this.snack.open(message, 'OK', { duration: 5000 });

   // Invalidate SWR and refresh
   this.rfqSWR.invalidateAll();
   await this.fetchAllDocuments();

   this.fullLoaderService.hideLoader()
   console.log(importResult,'importResult')
   console.log(parsed,'parsed payload')
  };
  reader.readAsArrayBuffer(file);
}

parseTemplateRows(rows: any[][]) {
  const payload: any = {
    quoteDetails: {},
    incotermDetails: {},
    supplierComment: '',
    freightForwarder: {},
    paymentTerms: {},
    lineItems: [],
    additionalCosts: [],
    costSummary: {}
  };

  const norm = (v: any) => (v || '').toString().trim().toLowerCase();
  let i = 0;

  while (i < rows.length) {
    // join all columns to catch section headers even if not in first column
    const rowText = rows[i].map(norm).join(' ');

    if (!rowText) { i++; continue; }

    // helper function
    const isSection = (name: string) => rowText.includes(name.toLowerCase());

    // === QUOTE DETAILS ===
    if (isSection('quote details')) {
      i++;
      while (i < rows.length && norm(rows[i][0])) {
        const key = (rows[i][0] || '').toString().trim();
        const val = rows[i][1] || '';
        payload.quoteDetails[this.normalizeKey(key)] = val;
        i++;
      }
      continue;
    }

    // === INCOTERM DETAILS ===
    if (isSection('incoterm details')) {
      i++;
      while (i < rows.length && norm(rows[i][0])) {
        const key = (rows[i][0] || '').toString().trim();
        const val = rows[i][1] || '';
        payload.incotermDetails[this.normalizeKey(key)] = val;
        i++;
      }
      continue;
    }

    // === SUPPLIER COMMENT ===
    if (isSection('supplier comment')) {
      i++;
      if (i < rows.length && (rows[i][1] || rows[i][0])) {
        payload.supplierComment = rows[i][1] || rows[i][0];
      }
      continue;
    }

    // === FREIGHT FORWARDER DETAILS ===
    if (isSection('freight forwarder details')) {
      i++;
      while (i < rows.length && norm(rows[i][0])) {
        const key = (rows[i][0] || '').toString().trim();
        const val = rows[i][1] || '';
        payload.freightForwarder[this.normalizeKey(key)] = val;
        i++;
      }
      continue;
    }

    // === PAYMENT TERMS ===
    if (isSection('payment terms')) {
      i++;
      while (i < rows.length && norm(rows[i][0])) {
        const key = (rows[i][0] || '').toString().trim();
        const val = rows[i][1] || '';
        payload.paymentTerms[this.normalizeKey(key)] = val;
        i++;
      }
      continue;
    }

    // === LINE ITEMS ===
    if (isSection('line items')) {
      i++;
      const headers = rows[i].map((h: any) => norm(h));
      i++;

      while (i < rows.length && norm(rows[i][0])) {
        const row = rows[i];
        const item: any = {};
        headers.forEach((h: string, idx: number) => {
          item[this.normalizeKey(h)] = row[idx];
        });
        payload.lineItems.push(item);
        i++;
      }
      continue;
    }

    // === ADDITIONAL COSTS ===
  
    if (isSection('additional costs')) {
      i++; // skip "Additional Costs" section header
      const headers = rows[i].map((h: any) => norm(h)); // read table header
      i++; // move past the table header
    
      let rowCount = 0;
    
      while (i < rows.length && rowCount < 5) {
        const row = rows[i];
    
        // Stop parsing if the next section starts (e.g., "Cost Summary")
        const rowText = row.map(norm).join(' ');
        if (rowText.includes('cost summary')) break;
    
        // skip empty rows
        if (!row.some((cell: any) => cell !== null && cell !== undefined && cell.toString().trim() !== '')) {
          i++;
          continue;
        }
    
        const obj: any = {};
    
        headers.forEach((h: string, idx: number) => {
          obj[this.normalizeKey(h)] = row[idx];
        });
    
        // Ensure numeric
        obj.additionalCost = Number(obj.additionalCost || 0);
    
        payload.additionalCosts.push(obj);
    
        rowCount++;
        i++;
      }
    
      // Fill remaining blank rows if fewer than 5
      while (payload.additionalCosts.length < 5) {
        payload.additionalCosts.push({ additionalCostDescription: '', additionalCost: 0 });
      }

      // Filter only rows with a non-empty description or non-zero cost
      payload.additionalCosts = payload.additionalCosts
      .map((c: any) => ({
        additionalCostDescription: c.additionalcostdescription || c.additionalCostDescription || '',
        additionalCost: Number(c.additionalcost || c.additionalCost || 0),
      }))
      // .filter((c: any) => c.additionalCostDescription.trim() !== '' && c.additionalCost !== 0);
      .filter((c: any) => c.additionalCost !== 0);
    
    

      console.log(payload.additionalCosts,'additionalCosts')
    
      continue;
    }
    

    // === COST SUMMARY ===
    if (isSection('cost summary')) {
      i++;
      while (i < rows.length && norm(rows[i][0])) {
        const key = (rows[i][0] || '').toString().trim();
        const val = rows[i][1] || '';
        payload.costSummary[this.normalizeKey(key)] = val;
        i++;
      }
      continue;
    }

    i++;
  }
  console.log(payload,'payload after parsing')
  return payload;
}


normalizeKey(key: string): string {
  return key.replace(/[^a-zA-Z0-9]+/g, '').toLowerCase();
}




async generateTemplate(rfqId: number, docStatus:string,refNo:string) {
  // Generate Quote Ref Number

  this.fullLoaderService.showLoader()
  if(docStatus == 'Unactioned'){

    const lastQuoteId = await this.quoteService.getlastQuoteId();
    const lastId = lastQuoteId[0]?.lastId || 0;
  
      this.templateData = this.templateData || {};
  
      this.templateData.quoteRef = 
  
         'Q-VSMPS-' +
          new Date().getFullYear().toString() +
          String(new Date().getMonth() + 1).padStart(2, '0') +
          String(new Date().getDate()).padStart(2, '0') +
          '-' +
          (lastId + 1)
  
      this.templateData.quoteRef =
        'Q-VSMPS-' +
        new Date().getFullYear().toString() +
        String(new Date().getMonth() + 1).padStart(2, '0') +
        String(new Date().getDate()).padStart(2, '0') +
        '-' +
        (lastId + 1);
    
      // Fetch RFQ details
      const params = {
        rfqId: rfqId,
        supplierId: Number(this.cookieService.get('userId')),
      };
  
    const data = await this.quoteService.fetchRfqDetails(params);
    console.log('Fetched RFQ Data →', data);
  
    // Transform Line Item Data
    if (data.lineItemData && data.lineItemData.length > 0) {
      const transformedData: any[] = data.lineItemData.map((item: any, index: number) => ({
        position: index + 1,
        id: null,
        partNumber: item.partNumber,
        supplierPartNumber: null,
        itemDescription: item.itemDescription,
        impaId: item.supplierProductId,
        buyerComment: item.buyerComments,
        supplierComment: '',
        customsCode: '',
        attachments: '',
        uom: item.uom,
        quantity: item.quantity,
        supplierUom: item.uom,
        supplierQuantity: item.quantity,
        unitCost: '',
        discount: '',
        totalCost: '',
        leadTime: '',
        isActive: 1,
      }));
      this.templateData.lineItemData = transformedData;
    } else {
      this.templateData.lineItemData = [];
    }
  

    // Prepare dropdown lists via hidden sheet to avoid Excel validation limits/repairs
    const countriesArr = this.toArray(this.countryData);
    const incotermsArr = this.toArray(this.incotermsData);
    const paymentTermsArr = this.toArray(this.paymentTermsData);
    const offeredQualityArr = this.toArray(this.offeredQualityData);
    const currencyArr = this.toArray(this.currencyData);
    const taxProfilesArr = this.toArray(this.taxStatusData);
    const today = new Date();
    const formattedDate = `${String(today.getDate()).padStart(2, '0')}-${String(today.getMonth() + 1).padStart(2, '0')}-${today.getFullYear()}`;
    

  
    // Create Workbook and Sheet
    const Excel = await import('exceljs');
    const fileSaverMod2 = await import('file-saver');
    const saveAs2 = (fileSaverMod2 as any).saveAs || (fileSaverMod2 as any).default;
    const workbook = new Excel.Workbook();
    const ws = workbook.addWorksheet('Quote Template');
    const listsSheet: any = workbook.addWorksheet('Lists', { state: 'hidden' });

    const writeListColumn = (colIndex: number, values: any[], selector: (x: any) => string) => {
      const cleaned = Array.from(new Set(values.map(selector).filter(Boolean)));
      cleaned.forEach((val, idx) => {
        listsSheet.getCell(idx + 1, colIndex).value = val;
      });
      return cleaned.length;
    };

    const countriesLen = writeListColumn(1, countriesArr, (q: any) => q.name ?? q.countryName ?? q.label ?? '');
    const incotermsLen = writeListColumn(2, incotermsArr, (q: any) => q.incotermCode ?? q.code ?? q.name ?? '');
    const paymentTermsLen = writeListColumn(3, paymentTermsArr, (q: any) => q.name ?? q.label ?? '');
    const offeredQualityLen = writeListColumn(4, offeredQualityArr, (q: any) => q.qualityDescription ?? q.name ?? '');
    const currencyLen = writeListColumn(5, currencyArr, (q: any) => q.currencyCode ?? q.code ?? '');
    const taxProfilesLen = writeListColumn(6, taxProfilesArr, (q: any) => q.applicableTaxProfile ?? q.name ?? '');

    const rangeRef = (colLetter: string, len: number) => len > 0 ? `Lists!$${colLetter}$1:$${colLetter}$${len}` : '';
  
    // === Helper Functions ===
    const addSectionHeader = (name: string) => {
      const row = ws.addRow([name]);
      row.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'D9E1F2' } };
      row.font = { bold: true };
      row.eachCell((cell: any) => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
      });
    };
  
    const addKeyValueRows = (rows: [string, string][]) => {
      rows.forEach(([key, value]) => {
        const r = ws.addRow([key, value]);
        r.eachCell((c: any) => (c.alignment = { vertical: 'middle' }));
      });
    };
  
    const addSpacing = () => ws.addRow([]);
  
    // === Title ===
    const title = ws.addRow(['Quote Import Template']);
    title.font = { size: 18, bold: true, color: { argb: '1F4E78' } };
    title.alignment = { horizontal: 'center', vertical: 'middle' };
    addSpacing();
  
    // === Quote Details ===
    addSectionHeader('Quote Details');
    addKeyValueRows([
      ['RFQ Ref No', refNo],
      ['Quote Ref No', this.templateData.quoteRef],
      ['Quotation Date', formattedDate],
      ['Price Good Until (Mandatory)', ''] 
    ]);
    const offeredQltyRow = ws.addRow(['Offered Quality (Mandatory)', '']);
    addKeyValueRows([
      ['For On Time Delivery Date (Mandatory)', ''],
      ['Quoted Delivery In Days', ''],
    ]);


    addSpacing();


    const offeredCell = offeredQltyRow.getCell(2);
    if (offeredQualityLen > 0) {
      offeredCell.dataValidation = {
        type: 'list',
        allowBlank: true,
        formulae: [rangeRef('D', offeredQualityLen)], 
        showErrorMessage: true,
        errorTitle: 'Invalid offered qualtity',
        error: 'Please select a valid offered qualtity from the list.',
      };
    }
  
    // === Incoterm Details ===
    addSectionHeader('Incoterm Details');

    const incotermStartRow = ws.addRow(['Incoterm', '']);
    ws.addRow(['Incoterm Location', '']);
    addSpacing();

  
    const incotermCell = incotermStartRow.getCell(2);
    if (incotermsLen > 0) {
      incotermCell.dataValidation = {
        type: 'list',
        allowBlank: true,
        formulae:  [rangeRef('B', incotermsLen)], 
        showErrorMessage: true,
        errorTitle: 'Invalid Incoterm',
        error: 'Please select a valid Incoterm from the list.',
      };
    }


    addSectionHeader('My Details');
    addKeyValueRows([
      ['Contact Name', data.rfqData[0].supplierCompanyName],
      ['Email', data.rfqData[0].supplierEmail],
      ['Telephone Number', data.rfqData[0].supplierPhone],
      ['Mobile Number', data.rfqData[0].supplierPhone] ,
      ['Company Email', data.rfqData[0].supplierEmail] 
    ]);

    addSpacing();
  
    // === Supplier Comment ===
    addSectionHeader('Supplier Comment');
    addKeyValueRows([['Supplier Comment', '']]);
    addSpacing();

    // === Supplier Comment ===
    addSectionHeader('Buyer Comment');
    addKeyValueRows([['Buyer Comment', data.rfqData[0].buyerComment]]);
    addSpacing();
  
    // === Freight Forwarder Details ===
    addSectionHeader('Freight Forwarder Details');
    addKeyValueRows([
      ['Freight Forwarder Company', ''],
      ['PIC', ''],
      ['Job Title', ''],
      ['Email', ''],
      ['Phone', ''],
      ['Fax', ''],
      ['Address', ''],
      ['Packaging', ''],
      ['Mode of Transport', ''],
    ]);
    addSpacing();
  
    // === Payment Terms ===
    addSectionHeader('Payment Terms');
    const paymentStartRow = ws.addRow(['Payment Terms', '']);
    addKeyValueRows([
      ['Terms and Condition', ''],
      ['Currency Instruction', '']
    ]);

    const currencyStartRow = ws.addRow(['Preferred Currency', '']);

    const currencycell = currencyStartRow.getCell(2);
    if (currencyLen > 0) {
      currencycell.dataValidation = {
        type: 'list',
        allowBlank: true,
        formulae: [rangeRef('E', currencyLen)], 
        showErrorMessage: true,
        errorTitle: 'Invalid currency',
        error: 'Please select a valid currency from the list.',
      };
    }

    addSpacing();


    const paymentell = paymentStartRow.getCell(2);
    if (paymentTermsLen > 0) {
      paymentell.dataValidation = {
        type: 'list',
        allowBlank: true,
        formulae: [rangeRef('C', paymentTermsLen)], 
        showErrorMessage: true,
        errorTitle: 'Invalid Payment Terms',
        error: 'Please select a valid Payment Terms from the list.',
      };
    }


     // === Buyer Payment Terms ===
     addSectionHeader('Buyer Payment Terms');
     addKeyValueRows([
       ['Billing Address',  data.rfqData[0].invoiceAddress],
       ['Applicable Tax Profile',  data.rfqData[0].buyerapplicableTaxProfile],
       ['Buyer Terms and Conditions',  data.rfqData[0].buyerTermsAndCondition],
       ['Buyer Payment Terms',  data.rfqData[0].buyerPaymentTerms],

     ]);
     addSpacing();
  
    // === Line Items ===
    addSectionHeader('Line Items');
  
    const lineItemHeader = ws.addRow([
      'S.No',
      'Part Number',
      'Supplier Part Number',
      'Item Description',
      'Buyer Comment',
      'Supplier Comment',
      'Customs Code',
      'Requested UOM',
      'Quoted UOM',
      'Requested Quantity',
      'Quoted Quantity',
      'Quoted Price',
      'Discount',
      'Total Quoted Price',
      'Lead Time',

      'position',
      'id',
      'impaId',
      'isActive',
      'Discounted Unit Cost'
    ]);
  
    lineItemHeader.font = { bold: true };
    lineItemHeader.eachCell((cell: any) => {
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });
  
    const lineItemStartRow = ws.lastRow!.number + 1;

    // Fill Line Items Dynamically
    if (this.templateData.lineItemData.length > 0) {
      this.templateData.lineItemData.forEach((item: any) => {
        
        const row = ws.addRow([
          item.position,
          item.partNumber || 'NA',
          item.supplierPartNumber || '',
          item.itemDescription || '',
          item.buyerComment || '',
          item.supplierComment || '',
          item.customsCode || '',
          item.uom || '',
          item.supplierUom || '',
          item.quantity ?? 0,
          item.supplierQuantity ?? 0,
          item.unitCost ?? '',
          item.discount ?? '',
          '',
          item.leadTime ?? '',

          item.position ?? '',
          item.id ?? '',
          item.impaId ?? '',
          item.isActive ?? '',
          ''

        ]);

        const excelRowIndex = row.number;
        
        // Insert formulas dynamically
        const qtyCol = 11;
        const unitCostCol = 12;
        const discountCol = 13;
        const discountedCol = 20;
        const totalCostCol = 14;

        // Discounted Unit Cost = Unit Cost * (1 - Discount / 100)
        row.getCell(discountedCol).value = {
          formula: `=${String.fromCharCode(64 + unitCostCol)}${excelRowIndex}*(1-(${String.fromCharCode(64 + discountCol)}${excelRowIndex}/100))`,
        };

        // Total Cost = Quantity * Discounted Unit Cost
        row.getCell(totalCostCol).value = {
          formula: `=${String.fromCharCode(64 + qtyCol)}${excelRowIndex}*${String.fromCharCode(64 + discountedCol)}${excelRowIndex}`,
        };

        row.eachCell((cell: any) => {
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
          };
        });
      });
    } else {
      const emptyRow = ws.addRow(Array(15).fill(''));
      emptyRow.eachCell((cell: any) => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
      });
    }


    const lineItemEndRow = ws.lastRow!.number;

    ws.getColumn(16).hidden = true; // position
    ws.getColumn(17).hidden = true; // id
    ws.getColumn(18).hidden = true; // impaid
    ws.getColumn(19).hidden = true; // is active
    ws.getColumn(20).hidden = true; // disocunted unit cost
  
    addSpacing();
  

    // === Additional Costs ===
    addSectionHeader('Additional Costs');
    const addCostHeader = ws.addRow(['Additional Cost Description', 'Additional Cost']);
    addCostHeader.font = { bold: true };
    addCostHeader.eachCell((cell: any) => {
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });

    // Capture additional cost row numbers
    const additionalCostRows: number[] = [];

    for (let i = 0; i < 5; i++) {
      const row = ws.addRow(['', '']);
      additionalCostRows.push(row.number);
      row.eachCell((cell: any) => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
      });
    }

    addSpacing();

    // === Cost Summary ===
    addSectionHeader('Cost Summary');

    const costSummaryStartRow = ws.lastRow!.number + 1;
    addKeyValueRows([
      ['Line Item Total', ''],
      ['Line Item Discount', ''],
      ['Line Item Subtotal', ''],
      ['General Discount(Percentage)', ''],
      ['General Discount', ''],
      ['Total Additional Cost', '']
    ]);


    const taxStatusStartRow = ws.addRow(['Tax Profile', '']);

    const taxStatuscell = taxStatusStartRow.getCell(2);
    if (taxProfilesLen > 0) {
      taxStatuscell.dataValidation = {
        type: 'list',
        allowBlank: true,
        formulae: [rangeRef('F', taxProfilesLen)], 
        showErrorMessage: true,
        errorTitle: 'Invalid tax status',
        error: 'Please select a valid tax prfile from the list.',
      };
    }
    addKeyValueRows([
      ['Tax Percentage', ''],
      ['Tax Value', ''],
      ['Total', ''],
    ]);

    // === Add formulas dynamically ===
    const totalCostColumn = 14;
    const discountColumn = 13;
    const discountedUnitCostColumn = 20;

    // Column indexes
    const qtyCol = 11;
    const unitCostCol = 12;

    // Line Item Total = SUMPRODUCT(Quantity * Unit Cost)
    ws.getCell(`B${costSummaryStartRow}`).value = {
      formula: `=SUMPRODUCT(${String.fromCharCode(64 + qtyCol)}${lineItemStartRow}:${String.fromCharCode(64 + qtyCol)}${lineItemEndRow},${String.fromCharCode(64 + unitCostCol)}${lineItemStartRow}:${String.fromCharCode(64 + unitCostCol)}${lineItemEndRow})`,
    };

    // Line Item Discount (sum of discount)
    // ws.getCell(`B${costSummaryStartRow + 1}`).value = {
    //   formula: `=SUM(${String.fromCharCode(64 + discountColumn)}${lineItemStartRow}:${String.fromCharCode(64 + discountColumn)}${lineItemEndRow})`,
    // };

    // Line Item Discount = SUM((qty*unitCost) - (qty*discountedUnitCost))
    ws.getCell(`B${costSummaryStartRow + 1}`).value = {
      formula: `
        =SUMPRODUCT(${String.fromCharCode(64 + qtyCol)}${lineItemStartRow}:${String.fromCharCode(64 + qtyCol)}${lineItemEndRow},
                    ${String.fromCharCode(64 + unitCostCol)}${lineItemStartRow}:${String.fromCharCode(64 + unitCostCol)}${lineItemEndRow})
         -
        SUMPRODUCT(${String.fromCharCode(64 + qtyCol)}${lineItemStartRow}:${String.fromCharCode(64 + qtyCol)}${lineItemEndRow},
                    ${String.fromCharCode(64 + discountedUnitCostColumn)}${lineItemStartRow}:${String.fromCharCode(64 + discountedUnitCostColumn)}${lineItemEndRow})
      `.replace(/\s+/g, "")
    };

    // Line Item Subtotal = Line Item Total - Line Item Discount
    ws.getCell(`B${costSummaryStartRow + 2}`).value = {
      formula: `=B${costSummaryStartRow}-B${costSummaryStartRow + 1}`,
    };

    // General Discount (Amount) = Line Item Subtotal * (General Discount Percentage / 100)
    ws.getCell(`B${costSummaryStartRow + 4}`).value = {
      formula: `=B${costSummaryStartRow + 2} * (B${costSummaryStartRow + 3} / 100)`
    };

    // Total Additional Cost = sum of all additional costs
    ws.getCell(`B${costSummaryStartRow + 5}`).value = {
      formula: `=SUM(${additionalCostRows.map((r) => `B${r}`).join(',')})`,
    };

    // tax profile calculation
    ws.getCell(`B${costSummaryStartRow + 7}`).value = {
      formula: `=IFERROR(
            --TRIM(MID(B${costSummaryStartRow + 6},
            FIND(" - ",B${costSummaryStartRow + 6}, FIND(" - ",B${costSummaryStartRow + 6}, FIND(" - ",B${costSummaryStartRow + 6})+1)+1)+3,
            LEN(B${costSummaryStartRow + 6})
          )),
          0
        )`
    };
 
    

     // tax value
    ws.getCell(`B${costSummaryStartRow + 8}`).value = {
      formula: `=B${costSummaryStartRow + 2} * (B${costSummaryStartRow + 7} / 100)`
    };



    // Total = Line Item Subtotal + Total Additional Cost - General Discount
    // ws.getCell(`B${costSummaryStartRow + 6}`).value = {
    //   formula: `=B${costSummaryStartRow + 2}+B${costSummaryStartRow + 4}-B${costSummaryStartRow + 4}`,
    // };

    // Total = Subtotal − General Discount + Additional Cost + Tax Value
    ws.getCell(`B${costSummaryStartRow + 9}`).value = {
      formula: `=B${costSummaryStartRow + 2} - B${costSummaryStartRow + 4} + B${costSummaryStartRow + 5} + B${costSummaryStartRow + 8}`
    };
  
    // === Sheet Settings ===
    ws.columns.forEach((col: any) => (col.width = 25));
    ws.views = [{ state: 'frozen', ySplit: 1 }];
  
    // === Export ===
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs2(blob, `quote_import_template_${this.templateData.quoteRef}.xlsx`);

  }


  this.fullLoaderService.hideLoader()

}



validateParsedQuote(parsedData: any) {
  const errors: string[] = [];

  // ---  Quote Details ---
  const qd = parsedData.quoteDetails || {};
  if (!qd.pricegooduntilmandatory)
    errors.push('Missing: Price Good Until (Mandatory)');
  if (!qd.offeredqualitymandatory) 
    errors.push('Missing: Offered Quality (Mandatory)');
  if (!parsedData.paymentTerms.preferredcurrency) 
    errors.push('Missing: Preferred Currency (Mandatory)');
  

  // ---  Line Items ---
  const lineItems = parsedData.lineItems || [];
  lineItems.forEach((item: any, index: number) => {
    const rowNum = index + 1;

    // Mandatory checks
    const requiredFields = [
      'requestedquantity',
      'quotedquantity',
      'quotedprice',
      'discount',
      'totalquotedprice',
      'leadtime',
    ];

    requiredFields.forEach((field) => {
      const value = item[field];
      if (value === null || value === undefined || value === '') {
        errors.push(`Line ${rowNum}: Missing value for "${field}"`);
      } else if (isNaN(Number(value))) {
        errors.push(`Line ${rowNum}: "${field}" should be a number`);
      }
    });


    const qty = Number(item.quotedquantity);
    const unitCost = Number(item.quotedprice);
    const discount = Number(item.discount);
    const totalCost = Number(item.totalquotedprice);

    if (!isNaN(qty) && !isNaN(unitCost) && !isNaN(discount) && !isNaN(totalCost)) {
      // Expected Calculations
      const discountedUnitCost = unitCost - discount;
      const expectedTotalCost = qty * discountedUnitCost;

      // Validate total cost formula
      // if (Math.abs(totalCost - expectedTotalCost) > 0.01) {
      //   errors.push(
      //     `Line ${rowNum}: Incorrect "Total Cost". Expected ${expectedTotalCost.toFixed(
      //       2
      //     )} (Quantity * (Unit Cost - Discount)), found ${totalCost}`
      //   );
      // }

      // Optional: check for negative or zero values
      if (qty <= 0) errors.push(`Line ${rowNum}: Quantity should be greater than 0`);
      if (unitCost < 0) errors.push(`Line ${rowNum}: Unit Cost cannot be negative`);
      if (discount < 0) errors.push(`Line ${rowNum}: Discount cannot be negative`);
    }
  
  });

  if(lineItems.length == 0){
    errors.push(`Line item can't be empty`);
  }


  // ---  Additional Costs ---
  if (parsedData.additionalCosts && parsedData.additionalCosts.length) {
    parsedData.additionalCosts = parsedData.additionalCosts.filter(
      (c: any) =>
        (c.additionalCostDescription && c.additionalCostDescription.trim() !== '') ||
        (c.additionalCost && Number(c.additionalCost) > 0)
    );
  }

  // ---  Return result ---
  if (errors.length > 0) {
    return { valid: false, errors };
  }
  return { valid: true, cleanedData: parsedData };
}


checkRequiredKeys(payload: any): { valid: boolean; missing: string[] } {
  const missing: string[] = [];

  const requiredStructure = {
    quoteDetails: [
      'rfqrefno',
      'quoterefno',
      'pricegooduntilmandatory',
      'offeredqualitymandatory',
      'forontimedeliverydatemandatory',
      'quoteddeliveryindays',
    ],
    incotermDetails: ['incoterm', 'incotermlocation'],
    supplierComment: true,
    freightForwarder: [
      'freightforwardercompany',
      'pic',
      'jobtitle',
      'email',
      'phone',
      'fax',
      'address',
      'packaging',
      'modeoftransport',
    ],
    paymentTerms: [
      'paymentterms',
      'termsandcondition',
      'currencyinstruction',
      'preferredcurrency',
    ],
    lineItems: [
      'partnumber',
      'supplierpartnumber',
      'itemdescription',
      'buyercomment',
      'suppliercomment',
      'customscode',
      'requesteduom',
      'quoteduom',
      'requestedquantity',
      'quotedquantity',
      'quotedprice',
      'discount',
      'totalquotedprice',
      'leadtime',
      'position',
      'id',
      'impaid',
      'isactive',
      'discountedunitcost',
    ],
    additionalCosts: ['additionalCostDescription', 'additionalCost'],
    costSummary: [
      'lineitemtotal',
      'lineitemdiscount',
      'lineitemsubtotal',
      'generaldiscountpercentage',
      'generaldiscount',
      'totaladditionalcost',
      'taxprofile',
      'taxpercentage',
      'taxvalue',
      'total',
    ],
  } as const;

  // --- Helper ---
  const checkKeys = (obj: any, requiredKeys: readonly string[], path: string) => {
    requiredKeys.forEach((key) => {
      if (!(key in obj)) missing.push(`${path}.${key}`);
    });
  };

  // --- Validate structure ---
  (Object.keys(requiredStructure) as (keyof typeof requiredStructure)[]).forEach((section) => {
    if (!(section in payload)) {
      missing.push(section);
      return;
    }

    const requiredKeys = requiredStructure[section];
    const sectionData = payload[section];

    if (requiredKeys === true) return; // e.g., supplierComment — only existence check

    if (Array.isArray(requiredKeys)) {
      if (Array.isArray(sectionData)) {
        if (sectionData.length > 0) {
          checkKeys(sectionData[0], requiredKeys, section);
        } else {
          requiredKeys.forEach((k) => missing.push(`${section}[].${k}`));
        }
      } else if (typeof sectionData === 'object') {
        checkKeys(sectionData, requiredKeys, section);
      }
    }
  });

  return {
    valid: missing.length === 0,
    missing,
  };
}

async getTaxDetails() {
  this.fullLoaderService.showLoader();
  let data = {
    supplierId: Number(this.cookieService.get('userId')),
  };
  const response = await this.SettingsService.getTaxDetailsBySupplier(data);
  this.taxStatusData = response.rows;
  const taxStatusDataOptions =  this.taxStatusData.map(q => q.applicableTaxProfile).join(',');
  this.fullLoaderService.hideLoader();
}








}
